import * as React from 'react';
import React__default, { forwardRef, useEffect, useLayoutEffect, createContext, useContext, useState, useRef } from 'react';
import Swiper$1, { Grid, Navigation, Pagination, A11y, Scrollbar, Autoplay, Manipulation } from 'swiper';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/** @license React v17.0.1
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
requireObjectAssign();var f=React__default,g=60103;reactJsxRuntime_production_min.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");reactJsxRuntime_production_min.Fragment=h("react.fragment");}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
	function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/** @license React v17.0.1
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;
	(function (exports) {

		if (process.env.NODE_ENV !== "production") {
		  (function() {

		var React = React__default;
		var _assign = requireObjectAssign();

		// ATTENTION
		// When adding new symbols to this file,
		// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
		// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
		// nor polyfill, then a plain number is used for performance.
		var REACT_ELEMENT_TYPE = 0xeac7;
		var REACT_PORTAL_TYPE = 0xeaca;
		exports.Fragment = 0xeacb;
		var REACT_STRICT_MODE_TYPE = 0xeacc;
		var REACT_PROFILER_TYPE = 0xead2;
		var REACT_PROVIDER_TYPE = 0xeacd;
		var REACT_CONTEXT_TYPE = 0xeace;
		var REACT_FORWARD_REF_TYPE = 0xead0;
		var REACT_SUSPENSE_TYPE = 0xead1;
		var REACT_SUSPENSE_LIST_TYPE = 0xead8;
		var REACT_MEMO_TYPE = 0xead3;
		var REACT_LAZY_TYPE = 0xead4;
		var REACT_BLOCK_TYPE = 0xead9;
		var REACT_SERVER_BLOCK_TYPE = 0xeada;
		var REACT_FUNDAMENTAL_TYPE = 0xead5;
		var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
		var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

		if (typeof Symbol === 'function' && Symbol.for) {
		  var symbolFor = Symbol.for;
		  REACT_ELEMENT_TYPE = symbolFor('react.element');
		  REACT_PORTAL_TYPE = symbolFor('react.portal');
		  exports.Fragment = symbolFor('react.fragment');
		  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
		  REACT_PROFILER_TYPE = symbolFor('react.profiler');
		  REACT_PROVIDER_TYPE = symbolFor('react.provider');
		  REACT_CONTEXT_TYPE = symbolFor('react.context');
		  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
		  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
		  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
		  REACT_MEMO_TYPE = symbolFor('react.memo');
		  REACT_LAZY_TYPE = symbolFor('react.lazy');
		  REACT_BLOCK_TYPE = symbolFor('react.block');
		  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
		  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
		  symbolFor('react.scope');
		  symbolFor('react.opaque.id');
		  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
		  symbolFor('react.offscreen');
		  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
		}

		var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
		var FAUX_ITERATOR_SYMBOL = '@@iterator';
		function getIteratorFn(maybeIterable) {
		  if (maybeIterable === null || typeof maybeIterable !== 'object') {
		    return null;
		  }

		  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

		  if (typeof maybeIterator === 'function') {
		    return maybeIterator;
		  }

		  return null;
		}

		var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

		function error(format) {
		  {
		    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		      args[_key2 - 1] = arguments[_key2];
		    }

		    printWarning('error', format, args);
		  }
		}

		function printWarning(level, format, args) {
		  // When changing this logic, you might want to also
		  // update consoleWithStackDev.www.js as well.
		  {
		    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
		    var stack = ReactDebugCurrentFrame.getStackAddendum();

		    if (stack !== '') {
		      format += '%s';
		      args = args.concat([stack]);
		    }

		    var argsWithFormat = args.map(function (item) {
		      return '' + item;
		    }); // Careful: RN currently depends on this prefix

		    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
		    // breaks IE9: https://github.com/facebook/react/issues/13610
		    // eslint-disable-next-line react-internal/no-production-logging

		    Function.prototype.apply.call(console[level], console, argsWithFormat);
		  }
		}

		// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

		var enableScopeAPI = false; // Experimental Create Event Handle API.

		function isValidElementType(type) {
		  if (typeof type === 'string' || typeof type === 'function') {
		    return true;
		  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


		  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
		    return true;
		  }

		  if (typeof type === 'object' && type !== null) {
		    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
		      return true;
		    }
		  }

		  return false;
		}

		function getWrappedName(outerType, innerType, wrapperName) {
		  var functionName = innerType.displayName || innerType.name || '';
		  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
		}

		function getContextName(type) {
		  return type.displayName || 'Context';
		}

		function getComponentName(type) {
		  if (type == null) {
		    // Host root, text node or just invalid type.
		    return null;
		  }

		  {
		    if (typeof type.tag === 'number') {
		      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
		    }
		  }

		  if (typeof type === 'function') {
		    return type.displayName || type.name || null;
		  }

		  if (typeof type === 'string') {
		    return type;
		  }

		  switch (type) {
		    case exports.Fragment:
		      return 'Fragment';

		    case REACT_PORTAL_TYPE:
		      return 'Portal';

		    case REACT_PROFILER_TYPE:
		      return 'Profiler';

		    case REACT_STRICT_MODE_TYPE:
		      return 'StrictMode';

		    case REACT_SUSPENSE_TYPE:
		      return 'Suspense';

		    case REACT_SUSPENSE_LIST_TYPE:
		      return 'SuspenseList';
		  }

		  if (typeof type === 'object') {
		    switch (type.$$typeof) {
		      case REACT_CONTEXT_TYPE:
		        var context = type;
		        return getContextName(context) + '.Consumer';

		      case REACT_PROVIDER_TYPE:
		        var provider = type;
		        return getContextName(provider._context) + '.Provider';

		      case REACT_FORWARD_REF_TYPE:
		        return getWrappedName(type, type.render, 'ForwardRef');

		      case REACT_MEMO_TYPE:
		        return getComponentName(type.type);

		      case REACT_BLOCK_TYPE:
		        return getComponentName(type._render);

		      case REACT_LAZY_TYPE:
		        {
		          var lazyComponent = type;
		          var payload = lazyComponent._payload;
		          var init = lazyComponent._init;

		          try {
		            return getComponentName(init(payload));
		          } catch (x) {
		            return null;
		          }
		        }
		    }
		  }

		  return null;
		}

		// Helpers to patch console.logs to avoid logging during side-effect free
		// replaying on render function. This currently only patches the object
		// lazily which won't cover if the log function was extracted eagerly.
		// We could also eagerly patch the method.
		var disabledDepth = 0;
		var prevLog;
		var prevInfo;
		var prevWarn;
		var prevError;
		var prevGroup;
		var prevGroupCollapsed;
		var prevGroupEnd;

		function disabledLog() {}

		disabledLog.__reactDisabledLog = true;
		function disableLogs() {
		  {
		    if (disabledDepth === 0) {
		      /* eslint-disable react-internal/no-production-logging */
		      prevLog = console.log;
		      prevInfo = console.info;
		      prevWarn = console.warn;
		      prevError = console.error;
		      prevGroup = console.group;
		      prevGroupCollapsed = console.groupCollapsed;
		      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

		      var props = {
		        configurable: true,
		        enumerable: true,
		        value: disabledLog,
		        writable: true
		      }; // $FlowFixMe Flow thinks console is immutable.

		      Object.defineProperties(console, {
		        info: props,
		        log: props,
		        warn: props,
		        error: props,
		        group: props,
		        groupCollapsed: props,
		        groupEnd: props
		      });
		      /* eslint-enable react-internal/no-production-logging */
		    }

		    disabledDepth++;
		  }
		}
		function reenableLogs() {
		  {
		    disabledDepth--;

		    if (disabledDepth === 0) {
		      /* eslint-disable react-internal/no-production-logging */
		      var props = {
		        configurable: true,
		        enumerable: true,
		        writable: true
		      }; // $FlowFixMe Flow thinks console is immutable.

		      Object.defineProperties(console, {
		        log: _assign({}, props, {
		          value: prevLog
		        }),
		        info: _assign({}, props, {
		          value: prevInfo
		        }),
		        warn: _assign({}, props, {
		          value: prevWarn
		        }),
		        error: _assign({}, props, {
		          value: prevError
		        }),
		        group: _assign({}, props, {
		          value: prevGroup
		        }),
		        groupCollapsed: _assign({}, props, {
		          value: prevGroupCollapsed
		        }),
		        groupEnd: _assign({}, props, {
		          value: prevGroupEnd
		        })
		      });
		      /* eslint-enable react-internal/no-production-logging */
		    }

		    if (disabledDepth < 0) {
		      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
		    }
		  }
		}

		var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
		var prefix;
		function describeBuiltInComponentFrame(name, source, ownerFn) {
		  {
		    if (prefix === undefined) {
		      // Extract the VM specific prefix used by each line.
		      try {
		        throw Error();
		      } catch (x) {
		        var match = x.stack.trim().match(/\n( *(at )?)/);
		        prefix = match && match[1] || '';
		      }
		    } // We use the prefix to ensure our stacks line up with native stack frames.


		    return '\n' + prefix + name;
		  }
		}
		var reentry = false;
		var componentFrameCache;

		{
		  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
		  componentFrameCache = new PossiblyWeakMap();
		}

		function describeNativeComponentFrame(fn, construct) {
		  // If something asked for a stack inside a fake render, it should get ignored.
		  if (!fn || reentry) {
		    return '';
		  }

		  {
		    var frame = componentFrameCache.get(fn);

		    if (frame !== undefined) {
		      return frame;
		    }
		  }

		  var control;
		  reentry = true;
		  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

		  Error.prepareStackTrace = undefined;
		  var previousDispatcher;

		  {
		    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
		    // for warnings.

		    ReactCurrentDispatcher.current = null;
		    disableLogs();
		  }

		  try {
		    // This should throw.
		    if (construct) {
		      // Something should be setting the props in the constructor.
		      var Fake = function () {
		        throw Error();
		      }; // $FlowFixMe


		      Object.defineProperty(Fake.prototype, 'props', {
		        set: function () {
		          // We use a throwing setter instead of frozen or non-writable props
		          // because that won't throw in a non-strict mode function.
		          throw Error();
		        }
		      });

		      if (typeof Reflect === 'object' && Reflect.construct) {
		        // We construct a different control for this case to include any extra
		        // frames added by the construct call.
		        try {
		          Reflect.construct(Fake, []);
		        } catch (x) {
		          control = x;
		        }

		        Reflect.construct(fn, [], Fake);
		      } else {
		        try {
		          Fake.call();
		        } catch (x) {
		          control = x;
		        }

		        fn.call(Fake.prototype);
		      }
		    } else {
		      try {
		        throw Error();
		      } catch (x) {
		        control = x;
		      }

		      fn();
		    }
		  } catch (sample) {
		    // This is inlined manually because closure doesn't do it for us.
		    if (sample && control && typeof sample.stack === 'string') {
		      // This extracts the first frame from the sample that isn't also in the control.
		      // Skipping one frame that we assume is the frame that calls the two.
		      var sampleLines = sample.stack.split('\n');
		      var controlLines = control.stack.split('\n');
		      var s = sampleLines.length - 1;
		      var c = controlLines.length - 1;

		      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
		        // We expect at least one stack frame to be shared.
		        // Typically this will be the root most one. However, stack frames may be
		        // cut off due to maximum stack limits. In this case, one maybe cut off
		        // earlier than the other. We assume that the sample is longer or the same
		        // and there for cut off earlier. So we should find the root most frame in
		        // the sample somewhere in the control.
		        c--;
		      }

		      for (; s >= 1 && c >= 0; s--, c--) {
		        // Next we find the first one that isn't the same which should be the
		        // frame that called our sample function and the control.
		        if (sampleLines[s] !== controlLines[c]) {
		          // In V8, the first line is describing the message but other VMs don't.
		          // If we're about to return the first line, and the control is also on the same
		          // line, that's a pretty good indicator that our sample threw at same line as
		          // the control. I.e. before we entered the sample frame. So we ignore this result.
		          // This can happen if you passed a class to function component, or non-function.
		          if (s !== 1 || c !== 1) {
		            do {
		              s--;
		              c--; // We may still have similar intermediate frames from the construct call.
		              // The next one that isn't the same should be our match though.

		              if (c < 0 || sampleLines[s] !== controlLines[c]) {
		                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
		                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

		                {
		                  if (typeof fn === 'function') {
		                    componentFrameCache.set(fn, _frame);
		                  }
		                } // Return the line we found.


		                return _frame;
		              }
		            } while (s >= 1 && c >= 0);
		          }

		          break;
		        }
		      }
		    }
		  } finally {
		    reentry = false;

		    {
		      ReactCurrentDispatcher.current = previousDispatcher;
		      reenableLogs();
		    }

		    Error.prepareStackTrace = previousPrepareStackTrace;
		  } // Fallback to just using the name if we couldn't make it throw.


		  var name = fn ? fn.displayName || fn.name : '';
		  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

		  {
		    if (typeof fn === 'function') {
		      componentFrameCache.set(fn, syntheticFrame);
		    }
		  }

		  return syntheticFrame;
		}
		function describeFunctionComponentFrame(fn, source, ownerFn) {
		  {
		    return describeNativeComponentFrame(fn, false);
		  }
		}

		function shouldConstruct(Component) {
		  var prototype = Component.prototype;
		  return !!(prototype && prototype.isReactComponent);
		}

		function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

		  if (type == null) {
		    return '';
		  }

		  if (typeof type === 'function') {
		    {
		      return describeNativeComponentFrame(type, shouldConstruct(type));
		    }
		  }

		  if (typeof type === 'string') {
		    return describeBuiltInComponentFrame(type);
		  }

		  switch (type) {
		    case REACT_SUSPENSE_TYPE:
		      return describeBuiltInComponentFrame('Suspense');

		    case REACT_SUSPENSE_LIST_TYPE:
		      return describeBuiltInComponentFrame('SuspenseList');
		  }

		  if (typeof type === 'object') {
		    switch (type.$$typeof) {
		      case REACT_FORWARD_REF_TYPE:
		        return describeFunctionComponentFrame(type.render);

		      case REACT_MEMO_TYPE:
		        // Memo may contain any component type so we recursively resolve it.
		        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

		      case REACT_BLOCK_TYPE:
		        return describeFunctionComponentFrame(type._render);

		      case REACT_LAZY_TYPE:
		        {
		          var lazyComponent = type;
		          var payload = lazyComponent._payload;
		          var init = lazyComponent._init;

		          try {
		            // Lazy may contain any component type so we recursively resolve it.
		            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
		          } catch (x) {}
		        }
		    }
		  }

		  return '';
		}

		var loggedTypeFailures = {};
		var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

		function setCurrentlyValidatingElement(element) {
		  {
		    if (element) {
		      var owner = element._owner;
		      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
		      ReactDebugCurrentFrame.setExtraStackFrame(stack);
		    } else {
		      ReactDebugCurrentFrame.setExtraStackFrame(null);
		    }
		  }
		}

		function checkPropTypes(typeSpecs, values, location, componentName, element) {
		  {
		    // $FlowFixMe This is okay but Flow doesn't know it.
		    var has = Function.call.bind(Object.prototype.hasOwnProperty);

		    for (var typeSpecName in typeSpecs) {
		      if (has(typeSpecs, typeSpecName)) {
		        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
		        // fail the render phase where it didn't fail before. So we log it.
		        // After these have been cleaned up, we'll let them throw.

		        try {
		          // This is intentionally an invariant that gets caught. It's the same
		          // behavior as without this statement except with a better message.
		          if (typeof typeSpecs[typeSpecName] !== 'function') {
		            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
		            err.name = 'Invariant Violation';
		            throw err;
		          }

		          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
		        } catch (ex) {
		          error$1 = ex;
		        }

		        if (error$1 && !(error$1 instanceof Error)) {
		          setCurrentlyValidatingElement(element);

		          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

		          setCurrentlyValidatingElement(null);
		        }

		        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
		          // Only monitor this failure once because there tends to be a lot of the
		          // same error.
		          loggedTypeFailures[error$1.message] = true;
		          setCurrentlyValidatingElement(element);

		          error('Failed %s type: %s', location, error$1.message);

		          setCurrentlyValidatingElement(null);
		        }
		      }
		    }
		  }
		}

		var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
		var hasOwnProperty = Object.prototype.hasOwnProperty;
		var RESERVED_PROPS = {
		  key: true,
		  ref: true,
		  __self: true,
		  __source: true
		};
		var specialPropKeyWarningShown;
		var specialPropRefWarningShown;
		var didWarnAboutStringRefs;

		{
		  didWarnAboutStringRefs = {};
		}

		function hasValidRef(config) {
		  {
		    if (hasOwnProperty.call(config, 'ref')) {
		      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

		      if (getter && getter.isReactWarning) {
		        return false;
		      }
		    }
		  }

		  return config.ref !== undefined;
		}

		function hasValidKey(config) {
		  {
		    if (hasOwnProperty.call(config, 'key')) {
		      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

		      if (getter && getter.isReactWarning) {
		        return false;
		      }
		    }
		  }

		  return config.key !== undefined;
		}

		function warnIfStringRefCannotBeAutoConverted(config, self) {
		  {
		    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
		      var componentName = getComponentName(ReactCurrentOwner.current.type);

		      if (!didWarnAboutStringRefs[componentName]) {
		        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

		        didWarnAboutStringRefs[componentName] = true;
		      }
		    }
		  }
		}

		function defineKeyPropWarningGetter(props, displayName) {
		  {
		    var warnAboutAccessingKey = function () {
		      if (!specialPropKeyWarningShown) {
		        specialPropKeyWarningShown = true;

		        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
		      }
		    };

		    warnAboutAccessingKey.isReactWarning = true;
		    Object.defineProperty(props, 'key', {
		      get: warnAboutAccessingKey,
		      configurable: true
		    });
		  }
		}

		function defineRefPropWarningGetter(props, displayName) {
		  {
		    var warnAboutAccessingRef = function () {
		      if (!specialPropRefWarningShown) {
		        specialPropRefWarningShown = true;

		        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
		      }
		    };

		    warnAboutAccessingRef.isReactWarning = true;
		    Object.defineProperty(props, 'ref', {
		      get: warnAboutAccessingRef,
		      configurable: true
		    });
		  }
		}
		/**
		 * Factory method to create a new React element. This no longer adheres to
		 * the class pattern, so do not use new to call it. Also, instanceof check
		 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
		 * if something is a React Element.
		 *
		 * @param {*} type
		 * @param {*} props
		 * @param {*} key
		 * @param {string|object} ref
		 * @param {*} owner
		 * @param {*} self A *temporary* helper to detect places where `this` is
		 * different from the `owner` when React.createElement is called, so that we
		 * can warn. We want to get rid of owner and replace string `ref`s with arrow
		 * functions, and as long as `this` and owner are the same, there will be no
		 * change in behavior.
		 * @param {*} source An annotation object (added by a transpiler or otherwise)
		 * indicating filename, line number, and/or other information.
		 * @internal
		 */


		var ReactElement = function (type, key, ref, self, source, owner, props) {
		  var element = {
		    // This tag allows us to uniquely identify this as a React Element
		    $$typeof: REACT_ELEMENT_TYPE,
		    // Built-in properties that belong on the element
		    type: type,
		    key: key,
		    ref: ref,
		    props: props,
		    // Record the component responsible for creating this element.
		    _owner: owner
		  };

		  {
		    // The validation flag is currently mutative. We put it on
		    // an external backing store so that we can freeze the whole object.
		    // This can be replaced with a WeakMap once they are implemented in
		    // commonly used development environments.
		    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
		    // the validation flag non-enumerable (where possible, which should
		    // include every environment we run tests in), so the test framework
		    // ignores it.

		    Object.defineProperty(element._store, 'validated', {
		      configurable: false,
		      enumerable: false,
		      writable: true,
		      value: false
		    }); // self and source are DEV only properties.

		    Object.defineProperty(element, '_self', {
		      configurable: false,
		      enumerable: false,
		      writable: false,
		      value: self
		    }); // Two elements created in two different places should be considered
		    // equal for testing purposes and therefore we hide it from enumeration.

		    Object.defineProperty(element, '_source', {
		      configurable: false,
		      enumerable: false,
		      writable: false,
		      value: source
		    });

		    if (Object.freeze) {
		      Object.freeze(element.props);
		      Object.freeze(element);
		    }
		  }

		  return element;
		};
		/**
		 * https://github.com/reactjs/rfcs/pull/107
		 * @param {*} type
		 * @param {object} props
		 * @param {string} key
		 */

		function jsxDEV(type, config, maybeKey, source, self) {
		  {
		    var propName; // Reserved names are extracted

		    var props = {};
		    var key = null;
		    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
		    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
		    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
		    // but as an intermediary step, we will use jsxDEV for everything except
		    // <div {...props} key="Hi" />, because we aren't currently able to tell if
		    // key is explicitly declared to be undefined or not.

		    if (maybeKey !== undefined) {
		      key = '' + maybeKey;
		    }

		    if (hasValidKey(config)) {
		      key = '' + config.key;
		    }

		    if (hasValidRef(config)) {
		      ref = config.ref;
		      warnIfStringRefCannotBeAutoConverted(config, self);
		    } // Remaining properties are added to a new props object


		    for (propName in config) {
		      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
		        props[propName] = config[propName];
		      }
		    } // Resolve default props


		    if (type && type.defaultProps) {
		      var defaultProps = type.defaultProps;

		      for (propName in defaultProps) {
		        if (props[propName] === undefined) {
		          props[propName] = defaultProps[propName];
		        }
		      }
		    }

		    if (key || ref) {
		      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

		      if (key) {
		        defineKeyPropWarningGetter(props, displayName);
		      }

		      if (ref) {
		        defineRefPropWarningGetter(props, displayName);
		      }
		    }

		    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
		  }
		}

		var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
		var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

		function setCurrentlyValidatingElement$1(element) {
		  {
		    if (element) {
		      var owner = element._owner;
		      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
		      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
		    } else {
		      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
		    }
		  }
		}

		var propTypesMisspellWarningShown;

		{
		  propTypesMisspellWarningShown = false;
		}
		/**
		 * Verifies the object is a ReactElement.
		 * See https://reactjs.org/docs/react-api.html#isvalidelement
		 * @param {?object} object
		 * @return {boolean} True if `object` is a ReactElement.
		 * @final
		 */

		function isValidElement(object) {
		  {
		    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
		  }
		}

		function getDeclarationErrorAddendum() {
		  {
		    if (ReactCurrentOwner$1.current) {
		      var name = getComponentName(ReactCurrentOwner$1.current.type);

		      if (name) {
		        return '\n\nCheck the render method of `' + name + '`.';
		      }
		    }

		    return '';
		  }
		}

		function getSourceInfoErrorAddendum(source) {
		  {
		    if (source !== undefined) {
		      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
		      var lineNumber = source.lineNumber;
		      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
		    }

		    return '';
		  }
		}
		/**
		 * Warn if there's no key explicitly set on dynamic arrays of children or
		 * object keys are not valid. This allows us to keep track of children between
		 * updates.
		 */


		var ownerHasKeyUseWarning = {};

		function getCurrentComponentErrorInfo(parentType) {
		  {
		    var info = getDeclarationErrorAddendum();

		    if (!info) {
		      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

		      if (parentName) {
		        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
		      }
		    }

		    return info;
		  }
		}
		/**
		 * Warn if the element doesn't have an explicit key assigned to it.
		 * This element is in an array. The array could grow and shrink or be
		 * reordered. All children that haven't already been validated are required to
		 * have a "key" property assigned to it. Error statuses are cached so a warning
		 * will only be shown once.
		 *
		 * @internal
		 * @param {ReactElement} element Element that requires a key.
		 * @param {*} parentType element's parent's type.
		 */


		function validateExplicitKey(element, parentType) {
		  {
		    if (!element._store || element._store.validated || element.key != null) {
		      return;
		    }

		    element._store.validated = true;
		    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

		    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
		      return;
		    }

		    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
		    // property, it may be the creator of the child that's responsible for
		    // assigning it a key.

		    var childOwner = '';

		    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
		      // Give the component that originally created this child.
		      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
		    }

		    setCurrentlyValidatingElement$1(element);

		    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

		    setCurrentlyValidatingElement$1(null);
		  }
		}
		/**
		 * Ensure that every element either is passed in a static location, in an
		 * array with an explicit keys property defined, or in an object literal
		 * with valid key property.
		 *
		 * @internal
		 * @param {ReactNode} node Statically passed child of any type.
		 * @param {*} parentType node's parent's type.
		 */


		function validateChildKeys(node, parentType) {
		  {
		    if (typeof node !== 'object') {
		      return;
		    }

		    if (Array.isArray(node)) {
		      for (var i = 0; i < node.length; i++) {
		        var child = node[i];

		        if (isValidElement(child)) {
		          validateExplicitKey(child, parentType);
		        }
		      }
		    } else if (isValidElement(node)) {
		      // This element was passed in a valid location.
		      if (node._store) {
		        node._store.validated = true;
		      }
		    } else if (node) {
		      var iteratorFn = getIteratorFn(node);

		      if (typeof iteratorFn === 'function') {
		        // Entry iterators used to provide implicit keys,
		        // but now we print a separate warning for them later.
		        if (iteratorFn !== node.entries) {
		          var iterator = iteratorFn.call(node);
		          var step;

		          while (!(step = iterator.next()).done) {
		            if (isValidElement(step.value)) {
		              validateExplicitKey(step.value, parentType);
		            }
		          }
		        }
		      }
		    }
		  }
		}
		/**
		 * Given an element, validate that its props follow the propTypes definition,
		 * provided by the type.
		 *
		 * @param {ReactElement} element
		 */


		function validatePropTypes(element) {
		  {
		    var type = element.type;

		    if (type === null || type === undefined || typeof type === 'string') {
		      return;
		    }

		    var propTypes;

		    if (typeof type === 'function') {
		      propTypes = type.propTypes;
		    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
		    // Inner props are checked in the reconciler.
		    type.$$typeof === REACT_MEMO_TYPE)) {
		      propTypes = type.propTypes;
		    } else {
		      return;
		    }

		    if (propTypes) {
		      // Intentionally inside to avoid triggering lazy initializers:
		      var name = getComponentName(type);
		      checkPropTypes(propTypes, element.props, 'prop', name, element);
		    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
		      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

		      var _name = getComponentName(type);

		      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
		    }

		    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
		      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
		    }
		  }
		}
		/**
		 * Given a fragment, validate that it can only be provided with fragment props
		 * @param {ReactElement} fragment
		 */


		function validateFragmentProps(fragment) {
		  {
		    var keys = Object.keys(fragment.props);

		    for (var i = 0; i < keys.length; i++) {
		      var key = keys[i];

		      if (key !== 'children' && key !== 'key') {
		        setCurrentlyValidatingElement$1(fragment);

		        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

		        setCurrentlyValidatingElement$1(null);
		        break;
		      }
		    }

		    if (fragment.ref !== null) {
		      setCurrentlyValidatingElement$1(fragment);

		      error('Invalid attribute `ref` supplied to `React.Fragment`.');

		      setCurrentlyValidatingElement$1(null);
		    }
		  }
		}

		function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
		  {
		    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
		    // succeed and there will likely be errors in render.

		    if (!validType) {
		      var info = '';

		      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
		        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
		      }

		      var sourceInfo = getSourceInfoErrorAddendum(source);

		      if (sourceInfo) {
		        info += sourceInfo;
		      } else {
		        info += getDeclarationErrorAddendum();
		      }

		      var typeString;

		      if (type === null) {
		        typeString = 'null';
		      } else if (Array.isArray(type)) {
		        typeString = 'array';
		      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
		        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
		        info = ' Did you accidentally export a JSX literal instead of a component?';
		      } else {
		        typeString = typeof type;
		      }

		      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
		    }

		    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
		    // TODO: Drop this when these are no longer allowed as the type argument.

		    if (element == null) {
		      return element;
		    } // Skip key warning if the type isn't valid since our key validation logic
		    // doesn't expect a non-string/function type and can throw confusing errors.
		    // We don't want exception behavior to differ between dev and prod.
		    // (Rendering will throw with a helpful message and as soon as the type is
		    // fixed, the key warnings will appear.)


		    if (validType) {
		      var children = props.children;

		      if (children !== undefined) {
		        if (isStaticChildren) {
		          if (Array.isArray(children)) {
		            for (var i = 0; i < children.length; i++) {
		              validateChildKeys(children[i], type);
		            }

		            if (Object.freeze) {
		              Object.freeze(children);
		            }
		          } else {
		            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
		          }
		        } else {
		          validateChildKeys(children, type);
		        }
		      }
		    }

		    if (type === exports.Fragment) {
		      validateFragmentProps(element);
		    } else {
		      validatePropTypes(element);
		    }

		    return element;
		  }
		} // These two functions exist to still get child warnings in dev
		// even with the prod transform. This means that jsxDEV is purely
		// opt-in behavior for better messages but that we won't stop
		// giving you warnings if you use production apis.

		function jsxWithValidationStatic(type, props, key) {
		  {
		    return jsxWithValidation(type, props, key, true);
		  }
		}
		function jsxWithValidationDynamic(type, props, key) {
		  {
		    return jsxWithValidation(type, props, key, false);
		  }
		}

		var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
		// for now we can ship identical prod functions

		var jsxs =  jsxWithValidationStatic ;

		exports.jsx = jsx;
		exports.jsxs = jsxs;
		  })();
		} 
	} (reactJsxRuntime_development));
	return reactJsxRuntime_development;
}

if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}

var jsxRuntimeExports = jsxRuntime.exports;

/**
 * modifier用のクラスを結合して返却します
 * @param modifiers modifierのclassNames
 * @return 先頭に-を付与したmodifier用のクラスの配列
 */
function mapModifiers() {
    var modifiers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        modifiers[_i] = arguments[_i];
    }
    return modifiers
        .reduce(function (acc, m) { return (!m ? acc : __spreadArray(__spreadArray([], acc, true), (typeof m === 'string' ? [m] : m), true)); }, [])
        .map(function (modifier) { return "-".concat(modifier); });
}
/**
 * state用のクラスを結合して返却します
 * @param states statesのclassNames
 * @return 先頭にis-を付与したstate用のクラスの配列
 */
function mapState() {
    var states = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        states[_i] = arguments[_i];
    }
    return states
        .reduce(function (acc, m) { return (!m ? acc : __spreadArray(__spreadArray([], acc, true), (typeof m === 'string' ? [m] : m), true)); }, [])
        .map(function (state) { return "is-".concat(state); });
}
/**
 * マルチクラスとして付与したいクラスを配列にして返却します。
 * @param adds マルチクラスのclassNames
 * @return マルチクラスのクラス用の文字列の配列
 */
function mapAdd() {
    var adds = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        adds[_i] = arguments[_i];
    }
    return adds
        .reduce(function (acc, m) { return (!m ? acc : __spreadArray(__spreadArray([], acc, true), (typeof m === 'string' ? [m] : m), true)); }, [])
        .map(function (add) { return add; });
}
/**
 * クラス名を結合するためのutil関数です。
 * ベースのクラス名にmodifier用, state用, util用, マルチクラス用のクラスを渡すとそれらを適切な形にし文字列として結合します
 *
 * @param baseClassName - ベースとなるクラス名
 * @param props -  ベースとなるクラス名
 * @return 全てのクラスを結合した文字列
 *
 * @example
 * ``` ts
 * const className={classNames('baseClassName', {
 *       modifiers: ['border', 'small'],
 *       states: 'active',
 *       utils: utilClassNames({ align: 'center' }),
 *       add: 'js-trigger1',
 *     })}
 * // `baseClassName -border -small is-active u-ai-center js-triggger`
 * ```
 *
 * Usage:
 *
 * ```tsx
 * const Component: React.FC = () => (
 *   <div
 *     className={classNames('baseClassName', {
 *       modifiers: ['border', 'small'],
 *       states: 'active',
 *       utils: utilClassNames({ align: 'center' }),
 *       add: 'js-trigger1',
 *     })}
 *   >
 *     Component
 *   </div>
 * );
 * ```
 */
function classNames(baseClassName, props) {
    if (!props)
        return baseClassName;
    var modifiers = props.modifiers, states = props.states, utils = props.utils, add = props.add;
    return [mapModifiers(modifiers), mapState(states), mapAdd(utils), mapAdd(add)]
        .flat()
        .reduce(function (classNames, suffix) { return (classNames += " ".concat(suffix)); }, baseClassName);
}
var UtilTextMaxLineClass = 'u-maxline';
/**
 * Utilクラス用のprefix
 */
var utilClassPrefix = {
    /** text */
    color: 'text',
    weight: 'text',
    textalign: 'text',
    fontsize: 'text',
    underline: 'text-underline',
    maxline: 'maxline',
    /** display */
    dn: 'dn',
    df: 'df',
    /** margin */
    mt: 'mt',
    mr: 'mr',
    mb: 'mb',
    ml: 'ml',
    /** margin-sp */
    mtsp: 'mtsp',
    mrsp: 'mrsp',
    mbsp: 'mbsp',
    mlsp: 'mlsp',
    /** padding */
    pt: 'pt',
    pr: 'pr',
    pb: 'pb',
    pl: 'pl',
    /** padding-sp */
    ptsp: 'ptsp',
    prsp: 'prsp',
    pbsp: 'pbsp',
    plsp: 'plsp',
    /** flex */
    align: 'ai',
    justify: 'jc',
    flexDirection: 'jc',
};
/**
 * Utilクラス用のclass名を結合して返却します
 * @param utils utilクラスのクラス用の文字列の配列
 */
function utilClassNames(utils) {
    return Object.entries(utils).map(function (_a) {
        var key = _a[0], value = _a[1];
        return "u-".concat(utilClassPrefix[key]).concat(typeof value !== 'boolean' ? "-".concat(value) : '');
    });
}
// memo
// 特定のtypeだけ抜きたい場合
// type UtilSpaceOnlyAlign = UtilAlign;
// type UtilSpaceExlude = Exclude<UtilSpaceValue, 0>;
// type UtilSpaceExtract = Extract<UtilSpaceValue, 0>;
// type UtilSpaceOmit = Omit<UtilSpace, 'mt'>;
// type UtilSpacePick = Pick<Util, 'mt'>;

/** アイコン */
var Icon = function (props) {
    var iconName = props.iconName, size = props.size, children = props.children, alt = props.alt;
    var overrideAlt = alt
        ? alt
        : iconName === 'icon_pdf' || iconName === 'icon_pdf_black'
            ? 'PDF'
            : iconName === 'icon_blank' || iconName === 'icon_blank_white' || iconName === 'icon_blank_gray'
                ? '新規ウィンドウで開く'
                : iconName === 'icon_modal'
                    ? 'モーダルを開く'
                    : undefined;
    var modifiers = __spreadArray([
        "size".concat(String(size))
    ], (iconName.includes('angle_left') || iconName.includes('angle_right') ? ['vertical'] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.mr !== undefined ? utilClassNames({ mr: props.mr }) : []), true), (props.ml !== undefined ? utilClassNames({ ml: props.ml }) : []), true), (props.mrsp !== undefined ? utilClassNames({ mrsp: props.mrsp }) : []), true), (props.mlsp !== undefined ? utilClassNames({ mlsp: props.mlsp }) : []), true), (props.dn !== undefined ? utilClassNames({ dn: props.dn }) : []), true);
    return (jsxRuntimeExports.jsxs("span", __assign({ className: classNames('a-icon', { modifiers: modifiers, utils: utils }) }, { children: [jsxRuntimeExports.jsx("img", { className: "a-icon_img", src: iconName.includes('menubar')
                    ? "".concat(props.isSrcProd ? 'https://cdn.askul.co.jp' : '', "/cms/assets/images/").concat(iconName, ".png")
                    : "".concat(props.isSrcProd ? 'https://cdn.askul.co.jp' : '', "/cms/assets/images/").concat(iconName, ".svg"), alt: overrideAlt || '', width: size, height: size }), children] })));
};
Icon.defaultProps = {
    size: 16,
};

/** spanタグで囲います<br />
 * inline要素で並べたいとき、文中でここだけ色を変えたい、などで使います。<br />
 * Textは見た目の調整のために上下を疑似要素でblovk要素として入れているので<br/>
 * TextでuseTagでspanにしても幅狭めるとinline要素として改行できず段落ちするため
 */
var Span = function (props) {
    var Tag = props.curtailmentLine ? 'del' : 'span';
    var modifiers = __spreadArray(__spreadArray(__spreadArray([], (props.srOnly ? ['srOnly'] : []), true), (props.spSrOnly ? ['spSrOnly'] : []), true), (props.curtailmentLine ? ['curtailmentLine'] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.mr !== undefined ? utilClassNames({ mr: props.mr }) : []), true), (props.ml !== undefined ? utilClassNames({ ml: props.ml }) : []), true), (props.mrsp !== undefined ? utilClassNames({ mrsp: props.mrsp }) : []), true), (props.mlsp !== undefined ? utilClassNames({ mlsp: props.mlsp }) : []), true), (props.color ? utilClassNames({ color: props.color }) : []), true), (props.weight ? utilClassNames({ weight: props.weight }) : []), true), (props.fontsize ? utilClassNames({ fontsize: props.fontsize }) : []), true), (props.underline ? utilClassNames({ underline: props.underline }) : []), true), (props.dn ? utilClassNames({ dn: props.dn }) : []), true), (props.pt !== undefined ? utilClassNames({ pt: props.pt }) : []), true), (props.maxline ? [UtilTextMaxLineClass] : []), true);
    return (jsxRuntimeExports.jsx(Tag, __assign({ className: classNames('a-span', { modifiers: modifiers, utils: utils, add: props.addClass }), "data-maxline": props.maxline }, { children: props.children })));
};
/**
 * 通常のテキストです。
 */
var Text = function (props) {
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.size ? [props.size] : []), true), (props.sizeSp ? ["sp".concat(props.sizeSp)] : []), true), (props.iconPos ? [props.iconPos] : []), true), (props.lineHeight ? ["lh".concat(props.lineHeight)] : []), true), (props.type ? [props.type] : []), true), (props.isNoWrap ? ["noWrap"] : []), true), (props.isBreakAll ? ["breakAll"] : []), true), (props.noLhCap ? ['noLhCap'] : []), true), (props.fontFamilyJp ? ['fontFamilyJp'] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true), (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.ml !== undefined ? utilClassNames({ ml: props.ml }) : []), true), (props.mr !== undefined ? utilClassNames({ mr: props.mr }) : []), true), (props.pr !== undefined ? utilClassNames({ pr: props.pr }) : []), true), (props.pb !== undefined ? utilClassNames({ pb: props.pb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true), (props.color ? utilClassNames({ color: props.color }) : []), true), (props.weight ? utilClassNames({ weight: props.weight }) : []), true), (props.fontsize ? utilClassNames({ fontsize: props.fontsize }) : []), true), (props.textalign ? utilClassNames({ textalign: props.textalign }) : []), true), (props.underline ? utilClassNames({ underline: props.underline }) : []), true), (props.maxline ? [UtilTextMaxLineClass] : []), true);
    var Tag = props.useTag || 'p';
    return (jsxRuntimeExports.jsxs(Tag, __assign({ className: classNames('a-text', { modifiers: modifiers, utils: utils, add: props.add }), "data-maxline": props.maxline }, { children: [props.icon && props.iconPos === 'front' && (jsxRuntimeExports.jsx(Icon, { iconName: props.icon, size: props.iconSize, alt: props.alt || '' })), props.children, props.icon && props.iconPos === 'back' && (jsxRuntimeExports.jsx(Icon, { iconName: props.icon, size: props.iconSize, alt: props.alt || '' }))] })));
};

var rel = 'noopener noreferrer';
/**
 * ユーティリティのリンクです。
 *
 * コンポーネントで内でリンクを使用する際にはovverrideClassを与えることでそのコンポーネント内で使用したいクラス名を上書きします。<br />
 * デフォルトでaタグに使用される属性はすべてpropsで流し込めます。<br />
 * `[href^="http"]`,`[href$=pdf]`には自動的には`target="_blank" rel="noopener noreferrer"`が付与されます。
 */
var Link = forwardRef(function (_a, ref) {
    var _b, _c;
    var overrideClass = _a.overrideClass, props = __rest(_a, ["overrideClass"]);
    var isOutside = ((_b = props.href) === null || _b === void 0 ? void 0 : _b.includes('http')) || ((_c = props.href) === null || _c === void 0 ? void 0 : _c.includes('.pdf'));
    var target = props.target ? props.target : isOutside ? '_blank' : undefined;
    var baseClass = overrideClass ? overrideClass : 'a-link';
    return (jsxRuntimeExports.jsx("a", __assign({}, props, { className: classNames(baseClass, {}), target: target, rel: target ? rel : undefined, ref: ref }, { children: props.children })));
});
Link.displayName = 'Link';

/**
 * テキストリンクです。<br />
 * `Text`コンポーネントなどの入れ子で使用します。
 */
var Textlink = forwardRef(function (_a, ref) {
    var size = _a.size, icon = _a.icon, iconPos = _a.iconPos, noIconMargin = _a.noIconMargin, color = _a.color, maxline = _a.maxline, disabled = _a.disabled, flex = _a.flex, mb = _a.mb, ml = _a.ml, kana = _a.kana, iconSize = _a.iconSize, addClass = _a.addClass, modal = _a.modal, bandmodal = _a.bandmodal, modalClose = _a.modalClose, historyBack = _a.historyBack, href = _a.href, isNoWrap = _a.isNoWrap, isBtn = _a.isBtn, target = _a.target, accordionTrigger = _a.accordionTrigger, accordionClosetext = _a.accordionClosetext, onClick = _a.onClick, props = __rest(_a, ["size", "icon", "iconPos", "noIconMargin", "color", "maxline", "disabled", "flex", "mb", "ml", "kana", "iconSize", "addClass", "modal", "bandmodal", "modalClose", "historyBack", "href", "isNoWrap", "isBtn", "target", "accordionTrigger", "accordionClosetext", "onClick"]);
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (size ? [size] : []), true), (icon && iconPos ? ["icon".concat(iconPos)] : []), true), (iconPos && noIconMargin ? ['noIconMargin'] : []), true), (color ? [color] : []), true), (disabled ? ['disabled'] : []), true), (flex ? ["flex"] : []), true), (isNoWrap ? ["noWrap"] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], ((flex === null || flex === void 0 ? void 0 : flex.align) ? utilClassNames({ align: flex.align }) : []), true), ((flex === null || flex === void 0 ? void 0 : flex.justify) ? utilClassNames({ justify: flex.justify }) : []), true), (mb !== undefined ? utilClassNames({ mb: mb }) : []), true), (ml !== undefined ? utilClassNames({ ml: ml }) : []), true), (maxline ? [UtilTextMaxLineClass] : []), true);
    var hasblank = (target === '_blank' || icon === 'icon_blank') && !(modal || bandmodal || icon === 'icon_pdf');
    var alt = modal || bandmodal ? 'モーダルを開く' : hasblank ? '新規ウィンドウで開く' : undefined;
    var add = __spreadArray(__spreadArray([], (addClass ? addClass : []), true), (accordionTrigger ? ['js-accordion_btn'] : []), true);
    iconSize =
        icon === 'icon_write' ||
            icon === 'icon_write_gray' ||
            icon === 'icon_trash' ||
            icon === 'icon_trash_white' ||
            icon === 'icon_folder_move' ||
            icon === 'icon_folder_close' ||
            icon === 'icon_folder_fill_close' ||
            icon === 'icon_folder_open' ||
            icon === 'icon_pdf' ||
            icon === 'icon_pdf_black'
            ? 20
            : iconSize;
    return (jsxRuntimeExports.jsxs(Link, __assign({ overrideClass: classNames('a-textlink', { modifiers: modifiers, utils: utils, add: add }), href: historyBack ? 'javascript:history.go(-1);' : modal || modalClose || bandmodal || isBtn ? 'javascript:;' : href, "data-kana": kana, "data-micromodal-trigger": modal, "data-bandmodal-trigger": bandmodal, "data-micromodal-close": modalClose, "data-maxline": maxline, target: hasblank ? '_blank' : target, ref: ref, onClick: onClick }, props, { children: [icon && iconPos === 'front' && jsxRuntimeExports.jsx(Icon, { iconName: icon, size: iconSize }), accordionClosetext ? (jsxRuntimeExports.jsx("span", __assign({ className: "js-accordion_btnText", "data-accordion-closetext": accordionClosetext, "data-accordion-opentext": accordionClosetext ? props.children : null }, { children: props.children }))) : (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: props.children })), icon && iconPos === 'back' && jsxRuntimeExports.jsx(Icon, { iconName: icon, size: iconSize, alt: alt }), accordionTrigger && jsxRuntimeExports.jsx("span", { className: "a-textlink_accordionIcon" })] })));
});
Textlink.displayName = 'Textlink';
Textlink.defaultProps = {
    iconPos: 'back',
};

function toCurrencyString(value) {
    if (typeof value === 'string') {
        return value;
    }
    var currencyValue = new String(value).replace(/,/g, '');
    while (currencyValue !== (currencyValue = currencyValue.replace(/^(-?\d+)(\d{3})/, '$1,$2')))
        ;
    return currencyValue;
}
function toOneDecimal(value) {
    return value.toFixed(1);
}
function nl2br(text) {
    var regex = /([\n\r])/g;
    return text.split(regex).map(function (line, idx) {
        return line.match(regex) ? jsxRuntimeExports.jsx("br", {}, idx) : line;
    });
}
function capitalizeFirstLetter(str) {
    return str[0].toUpperCase() + str.slice(1);
}

/**
 * 商品の評価用の星のグループです。<br />
 * 主にSimpleitemcardのような各商品カセット内で使用されています。<br />
 * Starbtnsと違い押下はできません。
 */
var StarIconGroup = function (props) {
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.isEvaluationVertical ? ['isEvaluationVertical'] : []), true), (props.isEvaluationLarge ? ['isEvaluationLarge'] : []), true), (props.reviewWithText ? ['reviewWithText'] : []), true), (typeof props.review !== 'number' && !props.reviewHref && !props.isReviewSimple ? ['wrap'] : []), true);
    var utils = __spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true);
    var MAX = 5;
    var stars = Array.from(new Array(MAX)).map(function (_, index) {
        var itemRate = index + 1;
        var starType = itemRate <= props.rate ? 'fill' : props.rate - itemRate >= -0.5 ? 'half' : 'none';
        return jsxRuntimeExports.jsx(Icon, { iconName: "icon_star_".concat(starType), size: props.size }, index);
    });
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-stariconGroup', { modifiers: modifiers, utils: utils }) }, { children: jsxRuntimeExports.jsxs("div", __assign({ className: "m-stariconGroup_inner" }, { children: [props.viewEvaluation && (jsxRuntimeExports.jsxs("div", __assign({ className: "m-stariconGroup_evaluation" }, { children: [jsxRuntimeExports.jsx("span", __assign({ className: "m-stariconGroup_evaluationTitle" }, { children: "\u30EC\u30D3\u30E5\u30FC" })), toOneDecimal(props.rate)] }))), jsxRuntimeExports.jsx("span", __assign({ title: "5\u3064\u661F\u306E\u3046\u3061".concat(props.rate), className: classNames('m-stariconGroup_rate', {
                        modifiers: __spreadArray([], (props.size ? ["size".concat(props.size)] : []), true),
                    }) }, { children: stars })), typeof props.review === 'number' && (jsxRuntimeExports.jsx("div", __assign({ className: "m-stariconGroup_review" }, { children: props.reviewHref ? (props.reviewWithText ? (jsxRuntimeExports.jsxs(Textlink, __assign({ href: props.reviewHref, addClass: props.isReviewAnchor ? ['js-anchorlink'] : [] }, { children: [props.review, "\u4EF6\u306E\u30EC\u30D3\u30E5\u30FC"] }))) : (jsxRuntimeExports.jsxs(Textlink, __assign({ href: props.reviewHref, addClass: props.isReviewAnchor ? ['js-anchorlink'] : [], "aria-label": "".concat(props.review, "\u4EF6\u306E\u30EC\u30D3\u30E5\u30FC") }, { children: ["\uFF08", props.review, "\uFF09"] })))) : props.isReviewSimple ? (jsxRuntimeExports.jsxs(Text, __assign({ size: "small" }, { children: ["\uFF08", props.review, "\uFF09"] }))) : (jsxRuntimeExports.jsxs(Text, { children: [props.review, "\u4EF6\u306E\u30EC\u30D3\u30E5\u30FC"] })) })))] })) })));
};
StarIconGroup.defaultProps = {
    rate: 5,
    size: 16,
};

/**
 * 金額表記です。<br />
 * valueをnumberで入れた場合、区切りのカンマは自動ではいります。
 */
var Price = function (props) {
    var Tag = props.useTag || 'p';
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.modifiers ? props.modifiers : []), true), (props.size ? [props.size] : []), true), (props.color ? [props.color] : []), true), (props.weight ? [props.weight] : []), true), (props.noLhCap ? ['noLhCap'] : []), true), (props.isSmallValueUnit ? ['isSmallValueUnit'] : []), true);
    var utils = __spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true);
    return (jsxRuntimeExports.jsxs(Tag, __assign({ className: classNames('a-price', { modifiers: modifiers, add: props.addClass, utils: utils }) }, { children: [props.beforeValue && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-price_before', {}) }, { children: props.beforeValue === '1個あたり' ? jsxRuntimeExports.jsx(Span, __assign({ color: "black" }, { children: props.beforeValue })) : props.beforeValue })), props.beforeValueNewLine && jsxRuntimeExports.jsx("br", {})] })), jsxRuntimeExports.jsxs("span", __assign({ className: classNames('a-price_value') }, { children: [props.sign && jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-price_sign') }, { children: props.sign })), !(props.notYen || props.isSmallValueUnit) && '￥', props.isSmallValueUnit && jsxRuntimeExports.jsx("span", __assign({ className: "a-price_valueUnit" }, { children: "\uFFE5" })), props.value < 0 && ' ', toCurrencyString(props.value), props.to ? jsxRuntimeExports.jsx("span", __assign({ className: "a-price_separete" }, { children: "~" })) : props.isFrom ? '~' : '', props.to && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [!props.notYen && '￥', toCurrencyString(props.to)] }))] })), props.afterValue && jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-price_after', {}) }, { children: props.afterValue }))] })));
};

/** ランキングアイコン<br/>
 * カテゴリー内のランキングなどで使います<br/>
 * https://askul.4digit.work/pub-slp-lst-019 などで使っています
 */
var RankingIcon = function (props) {
    var modifiers = __spreadArray(__spreadArray([], [
        props.rank === 1
            ? 'first'
            : props.rank === 2
                ? 'second'
                : props.rank === 3
                    ? 'third'
                    : props.rank === 4
                        ? 'fourth'
                        : props.rank > 10
                            ? 'other'
                            : 'fifth',
    ], false), (props.size ? [props.size] : []), true);
    return (jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-rankingicon js-lazy-img', {
            modifiers: modifiers,
        }) }, { children: props.rank })));
};
RankingIcon.defaultProps = {
    rank: 1,
    size: 'medium',
};

/**
 *
 * 画像用のコンポーネントです。<br />
 * デフォルトではlazyloadで読み込まれます。<br />
 * ロード前のダミー画像のアスペクト比が1:1のため、それ以外の場合は`aspectRatio`を使用してください。
 *
 */
var Img = function (_a) {
    var _b = _a.lazy, lazy = _b === void 0 ? true : _b, _c = _a.useTag, useTag = _c === void 0 ? 'div' : _c, props = __rest(_a, ["lazy", "useTag"]);
    var isStatic = props.height || props.width;
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (isStatic ? ['static'] : []), true), (props.pos ? [props.pos] : []), true), (props.radius ? ['radius'] : []), true), (props.circle ? ['circle'] : []), true), (props.borderd ? ['borderd'] : []), true), (props.isSelected ? ['selected'] : []), true);
    var states = __spreadArray([], (props.isDisabled ? ['disabled'] : []), true);
    var utils = __spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true);
    var Tag = useTag;
    var Img = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("span", __assign({ className: "a-img_imgWrap" }, { children: [jsxRuntimeExports.jsx("img", __assign({}, (lazy && !props.isAttrLoadingLazy && { 'data-src': props.src }), (props.aspectRatio && {
                        'data-aspectratio': props.aspectRatio,
                    }), { src: lazy && !props.isAttrLoadingLazy
                            ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN89h8AAtEB5wrzxXEAAAAASUVORK5CYII='
                            : props.src, className: "a-img_img".concat(lazy && !props.isAttrLoadingLazy ? ' js-lazy-img' : ''), alt: props.alt || '' }, (props.width && { width: props.width }), (props.height && { height: props.height }), (props.isAttrLoadingLazy && { loading: 'lazy' }))), props.overlayText && jsxRuntimeExports.jsx("span", __assign({ className: "a-img_overlayText" }, { children: props.overlayText }))] })), props.caption && (jsxRuntimeExports.jsx("div", __assign({ className: "a-img_caption" }, { children: jsxRuntimeExports.jsx(Text, __assign({ size: "small", useTag: "span" }, { children: props.caption })) })))] }));
    return props.href ? (jsxRuntimeExports.jsx(Link, __assign({ target: props.target, href: props.href, overrideClass: classNames('a-img', {
            modifiers: modifiers,
            states: states,
            utils: utils,
        }) }, { children: Img }))) : (jsxRuntimeExports.jsx(Tag, __assign({ id: props.id, className: classNames('a-img', {
            modifiers: modifiers,
            states: states,
            utils: utils,
        }) }, { children: Img })));
};

/** フォーム */
var labelsForm = {
    /** インプット */
    任意: { theme: 'gray' },
    必須: { theme: 'red' },
    Optional: { theme: 'gray' },
    Required: { theme: 'red' },
};
/** 検索ページ */
var LabelsSearch = {
    /** 販促系 */
    オリジナル: { theme: 'original', emphasis: true, iconName: 'icon_askul_people' },
    新着: {
        theme: 'orange',
        emphasis: true,
    },
    人気商品: { theme: 'orange', emphasis: true },
    期間限定価格: { theme: 'brown', emphasis: true },
    わけあり特価: { theme: 'darkgreen', emphasis: true },
    アウトレット: { theme: 'red', emphasis: true },
    プライスダウン: { theme: 'brightpink', emphasis: true },
    メーカーコラボ: { theme: 'original', emphasis: true },
    /** 医療系 */
    医薬品: { theme: 'moderatecyan' },
    特定保守管理: { theme: 'moderatecyan' },
    医薬部外品: { theme: 'moderatecyan' },
    一般医療機器: { theme: 'moderatecyan' },
    管理医療機器: { theme: 'moderatecyan' },
    指定医薬部外品: { theme: 'moderatecyan' },
    高度管理医療機器: { theme: 'moderatecyan' },
    体外診断用医薬品: { theme: 'moderatecyan' },
    第1類医薬品: { theme: 'moderatecyan' },
    第2類医薬品: { theme: 'moderatecyan' },
    '第2類医薬品（禁忌確認明点は専門家まで）': { theme: 'moderatecyan' },
    第3類医薬品: { theme: 'moderatecyan' },
    医療用医薬品: { theme: 'moderatecyan' },
    医療機器: { theme: 'moderatecyan' },
    '医薬品・医療機器混在': { theme: 'moderatecyan' },
    '医薬品・医療機器': { theme: 'moderatecyan' },
    /** 酒類 */
    酒類: { theme: 'brightblue' },
    /** 推奨品 */
    企業推奨品: { theme: 'brightDarkgreen' },
    /** 購入制限品 */
    購入制限品: { theme: 'palma' },
    /** パプリ商品 */
    パプリ商品: { theme: 'lightnavy' },
    /** クーポン対象 */
    '10%OFFクーポン対象': { theme: 'coupon', color: 'red' },
    '10%〜20%OFFクーポン対象': { theme: 'coupon', color: 'red' },
    /** 分納指定 */
    分納指定: { theme: 'lightblue' },
    /** 特別配送料が発生する内容 */
    大型商品: { theme: 'darkbrown' },
    組立設置サービス対象: { theme: 'brightgreen' },
    '翌々日配送家具・大型電化製品': { theme: 'grayblue' },
    /** 発送元を示す */
    アスクル在庫商品: { theme: 'lightnavy' },
    アスクル以外のサプライヤへご注文商品: { theme: 'darknavy' },
    お取り寄せ商品: { theme: 'darkorange' },
    'お取り寄せ商品（組立／設置付）': { theme: 'yellowishorange' },
    /** スイートアスクルスイート賞品 */
    アスクルスイート賞品: { theme: 'sweetpoint' },
};
/** 承認 */
var labelsApproval = {
    /** 配送内容 */
    定期配送対象商品: { theme: 'lightblue' },
    自動配送: { theme: 'paleblue' },
};
/** 三大機能 */
var labelsThreemajor = {
    /** 出荷状況 */
    出荷準備中: { theme: 'yellow' },
    出荷済み: { theme: 'lightgreen' },
    /** ご注文履歴 */
    承認待ち: { theme: 'yellow' },
    否認: { theme: 'gray' },
    受注待ち: { theme: 'lightorange' },
    受注済み: { theme: 'lightgreen' },
    /** 納品書同梱 */
    納品書同梱: { theme: 'white' },
};
/** 個人メニュー */
var labelsPersonalmenu = {
    /** 登録情報 */
    企業代表者: { theme: 'lightblue' },
    企業標準: { theme: 'lightnavy' },
    部門標準: { theme: 'darkgreen' },
    部門独自: { theme: 'darkgreen' },
    /** お知らせ */
    確認リスト: { theme: 'paleblue' },
    マイカタログ: { theme: 'lightblue' },
    クーポン: { theme: 'coupon', color: 'red' },
    お知らせ: { theme: 'lightorange' },
    /** 定期配送サービスお申込み一覧 */
    注文申請: { theme: 'lightblue' },
    承認済み: { theme: 'lightgreen' },
};
/** レジ */
var labelsRegister = {
    /** クーポン利用 */
    クーポン利用: { theme: 'coupon', color: 'red' },
    /** 金銭関連 */
    特別割引率: { theme: 'lightblue' },
    特別価格: { theme: 'lightblue' },
    アスクルへのお支払い: { theme: 'lightblue' },
    /** 対象外 */
    スイートポイント対象外: { theme: 'notApplicable', color: 'lightgray' },
    累積購入割引対象外: { theme: 'notApplicable', color: 'lightgray' },
    マイレージ対象外: { theme: 'notApplicable', color: 'lightgray' },
};
/** 変更・キャンセル */
var labelsChangeCancel = {
    変更: { theme: 'lightblue' },
    キャンセル: { theme: 'lightblue' },
    取消し: { theme: 'lightblue' },
    /** 置き場所指定 */
    '置き場所指定：利用しない': { theme: 'lightblue', iconName: 'icon_placement' },
    玄関横: { theme: 'lightgreen', iconName: 'icon_placement_check' },
    オフィス内受付前: { theme: 'lightgreen', iconName: 'icon_placement_check' },
    宅配ボックス: { theme: 'lightgreen', iconName: 'icon_placement_check' },
    物置: { theme: 'lightgreen', iconName: 'icon_placement_check' },
    メーターボックス: { theme: 'lightgreen', iconName: 'icon_placement_check' },
    '建物内受付／管理人': { theme: 'lightgreen', iconName: 'icon_placement_check' },
    車庫: { theme: 'lightgreen', iconName: 'icon_placement_check' },
    自転車のカゴ: { theme: 'lightgreen', iconName: 'icon_placement_check' },
    '建物受付／管理人': { theme: 'lightgreen', iconName: 'icon_placement_check' },
    /** 時間帯指定 */
    '時間帯指定 指定可': { theme: 'lightblue', iconName: 'icon_clock' },
    '8:00~12:00': { theme: 'lightgreen', iconName: 'icon_time_check' },
    '14:00~16:00': { theme: 'lightgreen', iconName: 'icon_time_check' },
    '16:00~18:00': { theme: 'lightgreen', iconName: 'icon_time_check' },
    '18:00~20:00': { theme: 'lightgreen', iconName: 'icon_time_check' },
    '19:00~21:00': { theme: 'lightgreen', iconName: 'icon_time_check' },
    '午前中（12時まで）': { theme: 'lightgreen', iconName: 'icon_time_check' },
    '時間帯指定：指定なし': { theme: 'lightblue', iconName: 'icon_clock' },
    '置き場所指定 利用可': { theme: 'lightblue', iconName: 'icon_placement' },
    'お急ぎ便：指定なし': { theme: 'lightblue', iconName: 'icon_expressdelivery' },
    お急ぎ便: { theme: 'lightgreen', iconName: 'icon_expressdelivery_check' },
    /** お届け先 */
    お届け先変更不可: { theme: 'notApplicable', color: 'lightgray' },
};
/** スイートポイント */
var labelsSweetpoint = {
    /** 賞品詳細 */
    直送品: { theme: 'orange' },
    個包装: { theme: 'brightpink' },
    小袋: { theme: 'yellowishorange' },
    冷凍: { theme: 'darkpaleblue' },
    冷蔵: { theme: 'blue' },
    大袋: { theme: 'darkbrown' },
    /** お知らせ */
    新着賞品: { theme: 'orange' },
    ニュース: { theme: 'navy' },
    コンテンツ: { theme: 'darkgreen' },
};
/** お知らせ関連ラベル */
var labelsNews = {
    NEW: { theme: 'orange', size: 'small' },
    リコール: { theme: 'red', size: 'small' },
};
/** 設定 */
var labelsSetting = {
    /** 承認ルール設定中 */
    承認ルールに設定中: { theme: 'yellow' },
};
/** 管理者登録 */
var labelsManagement = {
    担当販売店から依頼: { theme: 'lightorange' },
};
/** クーポン関連ラベル */
var labelsLarge = {
    受注待ち: { theme: 'lightorange' },
    受注済み: { theme: 'lightgreen' },
};
// const borderedLabels: TagItem = {};
var allStaticTags = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, labelsForm), LabelsSearch), labelsApproval), labelsThreemajor), labelsPersonalmenu), labelsRegister), labelsChangeCancel), labelsSweetpoint), labelsNews), labelsSetting), labelsManagement), labelsLarge);
var allStaticBorderedLabel = __assign(__assign({}, allStaticTags), { 承認待ち: { theme: 'yellow' }, 受注待ち: { theme: 'lightorange' }, 受注済み: { theme: 'lightgreen' } });
var allStaticLargeLabel = __assign(__assign({}, allStaticTags), { 承認待ち: { size: 'large', theme: 'yellow' }, 否認: { size: 'large', theme: 'gray' }, 受注待ち: { size: 'large', theme: 'lightorange' }, 受注済み: { size: 'large', theme: 'lightgreen' } });
/**
 * タグです。<br />
 * 複数並べいる場合は`TagList`でラップしてください。
 *
 */
var Tag = function (props) {
    var modifiersProps = __assign(__assign(__assign(__assign({}, (props.label ? allStaticTags[props.label] : {})), (props.label && props.size === 'large' ? allStaticLargeLabel[props.label] : {})), (props.label && props.bordered ? allStaticBorderedLabel[props.label] : {})), props);
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], ((modifiersProps === null || modifiersProps === void 0 ? void 0 : modifiersProps.theme) ? ["bg".concat(capitalizeFirstLetter(modifiersProps.theme))] : []), true), ((modifiersProps === null || modifiersProps === void 0 ? void 0 : modifiersProps.color) ? [modifiersProps.color] : []), true), ((modifiersProps === null || modifiersProps === void 0 ? void 0 : modifiersProps.size) ? [modifiersProps.size] : []), true), (modifiersProps.rounded ? ['rounded'] : []), true), (modifiersProps.bordered ? ['bordered'] : []), true), ((modifiersProps === null || modifiersProps === void 0 ? void 0 : modifiersProps.emphasis) ? ['emphasis'] : []), true), (!(modifiersProps === null || modifiersProps === void 0 ? void 0 : modifiersProps.theme) ? ['noTheme'] : []), true);
    var utils = __spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true);
    var Tag = props.label === 'アスクルスイート賞品' ? 'a' : 'span';
    return (jsxRuntimeExports.jsxs(Tag, __assign({ className: classNames('a-tag', { modifiers: modifiers, utils: utils, add: props.addClass }), href: props.label === 'アスクルスイート賞品' ? 'dummy' : undefined }, { children: [(modifiersProps === null || modifiersProps === void 0 ? void 0 : modifiersProps.iconName) && jsxRuntimeExports.jsx(Icon, { iconName: modifiersProps.iconName, size: 20 }), props.label === 'アスクルスイート賞品' && (jsxRuntimeExports.jsx(Img, { src: "/cms/assets/images/logo/logo_sweetpoint_inline.png", alt: "ASKUL sweet", aspectRatio: "98/12", useTag: "span", href: "" })), props.label === '第2類医薬品（禁忌確認明点は専門家まで）' ? (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: ["\u7B2C", jsxRuntimeExports.jsx("span", __assign({ className: "a-tag_medicalDecoration" }, { children: "2" })), "\u985E\u533B\u85AC\u54C1\uFF08\u7981\u5FCC\u78BA\u8A8D\u660E\u70B9\u306F\u5C02\u9580\u5BB6\u307E\u3067\uFF09"] })) : (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: props.label || props.customLabel }))] })));
};
/** Tagのwrapper要素です。 */
var TagList = function (props) {
    var UseTagWrap = props.useTag || 'div';
    var UseTagList = props.useTag || 'ul';
    var UseTagListItem = props.useTag || 'li';
    var listModifiers = __spreadArray([], (props.vertical ? ['vertical'] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true), (props.dn ? utilClassNames({ dn: props.dn }) : []), true);
    return (jsxRuntimeExports.jsx(UseTagWrap, __assign({ className: classNames('a-taglist', { utils: utils, modifiers: props.tagListModifiers }) }, { children: jsxRuntimeExports.jsx(UseTagList, __assign({ className: classNames('a-taglist_list', { modifiers: listModifiers }) }, { children: props.tags &&
                props.tags.map(function (tag, idx) { return (jsxRuntimeExports.jsx(UseTagListItem, __assign({ className: classNames('a-taglist_item', {}) }, { children: jsxRuntimeExports.jsx(Tag, __assign({}, tag)) }), idx)); }) })) })));
};

/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
/**
 * Lower case as a function.
 */
function lowerCase(str) {
    return str.toLowerCase();
}

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */
function noCase(input, options) {
    if (options === void 0) { options = {}; }
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while (result.charAt(start) === "\0")
        start++;
    while (result.charAt(end - 1) === "\0")
        end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
    if (re instanceof RegExp)
        return input.replace(re, value);
    return re.reduce(function (input, re) { return input.replace(re, value); }, input);
}

/**
 * Upper case the first character of an input string.
 */
function upperCaseFirst(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}

function capitalCaseTransform(input) {
    return upperCaseFirst(input.toLowerCase());
}
function capitalCase(input, options) {
    if (options === void 0) { options = {}; }
    return noCase(input, __assign({ delimiter: " ", transform: capitalCaseTransform }, options));
}

function headerCase(input, options) {
    if (options === void 0) { options = {}; }
    return capitalCase(input, __assign({ delimiter: "-" }, options));
}

/**
 * 通知の数字のパーツです
 */
var NoticeNum = function (props) {
    var utils = __spreadArray([], (props.ml !== undefined ? utilClassNames({ ml: props.ml }) : []), true);
    return props.num ? jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-noticeNum', { utils: utils }) }, { children: props.num })) : null;
};

/**
 * 白：通常、青：フォワード、オレンジ：コンバージョン（アクション）、赤：破壊的アクション<br />
 * 高さとフォントサイズはpc, sp共通でクラスとの関係は下記になります。
 *
 * | class | height | fontsize |
 * |---|---|---|
 * |- |48px |14px|
 * |small |32px |12px|
 * |xsmall |24px |12px|
 */
var Btn = function (_a) {
    _a.onClick; var current = _a.current, disabled = _a.disabled, selected = _a.selected, modifiers = _a.modifiers, href = _a.href, type = _a.type, isTextShow = _a.isTextShow, icon = _a.icon, iconPos = _a.iconPos, iconSize = _a.iconSize, modalClose = _a.modalClose, add = _a.add, useSpan = _a.useSpan, noticeNum = _a.noticeNum, accordionTrigger = _a.accordionTrigger, textFullWidth = _a.textFullWidth, addcart = _a.addcart, fontsize = _a.fontsize, ariaLabel = _a.ariaLabel, id = _a.id, buttonOnClick = _a.buttonOnClick, maxline = _a.maxline, dataAttr = _a.dataAttr, props = __rest(_a, ["onClick", "current", "disabled", "selected", "modifiers", "href", "type", "isTextShow", "icon", "iconPos", "iconSize", "modalClose", "add", "useSpan", "noticeNum", "accordionTrigger", "textFullWidth", "addcart", "fontsize", "ariaLabel", "id", "buttonOnClick", "maxline", "dataAttr"]);
    var InnerTag = props.useInnerTag || 'span';
    var addModifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (modifiers || []), true), (iconPos ? ["icon".concat(headerCase(iconPos))] : []), true), (noticeNum ? ['noticeNum'] : []), true), (accordionTrigger ? ['accordionTrigger'] : []), true), (fontsize ? ["font".concat(headerCase(fontsize))] : []), true), (isTextShow ? ['text'] : []), true), (maxline ? ['hasMaxline'] : []), true);
    var states = __spreadArray(__spreadArray(__spreadArray([], (current ? ['current'] : []), true), (disabled ? ['disabled'] : []), true), (selected ? ['selected'] : []), true);
    if (accordionTrigger) {
        add = __spreadArray([], (accordionTrigger && ['js-accordion_btn']), true);
    }
    if ((href === null || href === void 0 ? void 0 : href.startsWith('#')) && href.length > 1) {
        add = ['js-anchorlink'];
    }
    var utils = __spreadArray(__spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true), (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true);
    var Tag = useSpan ? (jsxRuntimeExports.jsx("span", __assign({ className: classNames('m-btn', { modifiers: addModifiers, states: states, add: add, utils: utils }), id: id }, { children: jsxRuntimeExports.jsxs("span", __assign({ className: "m-btn_inner" }, { children: [props.children && (jsxRuntimeExports.jsx("span", __assign({ className: classNames('m-btn_text', { modifiers: __spreadArray([], (textFullWidth ? ['full'] : []), true) }), "data-maxline": maxline }, { children: props.children }))), icon && (jsxRuntimeExports.jsx("span", __assign({ className: "m-btn_icon" }, { children: jsxRuntimeExports.jsx(Icon, { iconName: icon, size: iconSize }) })))] })) }))) : href ? (jsxRuntimeExports.jsx(Link, __assign({ overrideClass: classNames('m-btn', {
            modifiers: addModifiers,
            states: states,
            add: add,
            utils: utils,
        }), id: id, href: !props.isNotDisabledHref && (selected || disabled) ? undefined : href, "aria-label": ariaLabel, target: props.target, "data-micromodal-trigger": props.modal, "data-bandmodal-trigger": props.bandmodal, "data-pc": props.pcOnlyModal, "data-sp": props.spOnlyModal }, (modalClose && { 'data-micromodal-close': modalClose }), { children: jsxRuntimeExports.jsxs(InnerTag, __assign({ className: "m-btn_inner" }, { children: [props.children && (jsxRuntimeExports.jsx(InnerTag, __assign({ className: classNames('m-btn_text', { modifiers: __spreadArray([], (textFullWidth ? ['full'] : []), true) }), "data-maxline": maxline }, { children: props.children }))), icon && (jsxRuntimeExports.jsx("span", __assign({ className: "m-btn_icon" }, { children: jsxRuntimeExports.jsx(Icon, { iconName: icon, size: iconSize }) }))), noticeNum && jsxRuntimeExports.jsx(NoticeNum, { num: noticeNum })] })) }))) : (jsxRuntimeExports.jsx("button", __assign({}, dataAttr, { className: classNames('m-btn', { modifiers: addModifiers, states: states, add: add, utils: utils }), "aria-label": ariaLabel, onClick: buttonOnClick, disabled: disabled, type: type, "data-micromodal-trigger": props.modal, "data-bandmodal-trigger": props.bandmodal }, (modalClose && { 'data-micromodal-close': modalClose }), { "data-pc": props.pcOnlyModal, "data-sp": props.spOnlyModal, "data-addcart-trigger": addcart, id: id, ref: props.buttonRef }, { children: jsxRuntimeExports.jsxs("span", __assign({ className: "m-btn_inner" }, { children: [props.children && (jsxRuntimeExports.jsx("span", __assign({ className: classNames('m-btn_text', { modifiers: __spreadArray([], (textFullWidth ? ['full'] : []), true) }), "data-maxline": maxline }, { children: props.children }))), icon && (jsxRuntimeExports.jsx("span", __assign({ className: "m-btn_icon" }, { children: jsxRuntimeExports.jsx(Icon, { iconName: icon, size: iconSize && iconSize }) }))), noticeNum && jsxRuntimeExports.jsx(NoticeNum, { num: noticeNum })] })) })));
    return Tag;
};
Btn.defaultProps = {
    modifiers: ['base'],
    type: 'button',
};

/**
 * 汎用的なboxです。<br />
 * BoxbarはBoxと組み合わせて使用します。（直下に配置）<br />
 * Boxのpaddingを打ち消してBoxheadの下やBox内部に表示します。
 *
 */
var Box = function (_a) {
    var _b = _a.maxHeightUnit, maxHeightUnit = _b === void 0 ? 'px' : _b, noRadius = _a.noRadius, hasBalloon = _a.hasBalloon, isSpFull = _a.isSpFull, props = __rest(_a, ["maxHeightUnit", "noRadius", "hasBalloon", "isSpFull"]);
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.spacing ? [props.spacing] : []), true), (props.theme ? [props.theme] : []), true), (props.border ? [props.border] : []), true), (props.align ? [props.align] : []), true), (props.scrollable ? ['scrollable'] : []), true), (props.spScrollable ? ['spScrollable'] : []), true), (noRadius ? ['noRadius'] : []), true), (hasBalloon ? ['hasBalloon'] : []), true), (isSpFull ? ['spFull'] : []), true), (props.isOverflowHidden ? ['overflowHidden'] : []), true), (props.isSticky ? ['sticky'] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true), (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true), (props.mtsp !== undefined ? utilClassNames({ mtsp: props.mtsp }) : []), true), (props.dn ? utilClassNames({ dn: props.dn }) : []), true);
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames('a-box', {
            modifiers: modifiers,
            utils: utils,
            add: props.addClass,
        }), style: {
            maxHeight: typeof props.maxHeight === 'number' ? "".concat(props.maxHeight).concat(maxHeightUnit) : undefined,
            maxWidth: props.maxWidth,
            height: props.height,
        }, id: props.id }, { children: props.children })));
};
Box.defaultProps = {
    noRadius: false,
};

/**
 * データリストのコンポーネントです。<br />
 * dtタグに入れたいものはprop`title`で渡してください。
 */
var Dl = function (props) {
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.size ? [props.size] : []), true), (props.space ? ["space".concat(props.space)] : []), true), (props.lineHeight ? [props.lineHeight] : []), true), (props.whiteSpace ? [props.whiteSpace] : []), true), (props.fontWeight ? (Array.isArray(props.fontWeight) ? props.fontWeight : [props.fontWeight]) : []), true), (props.noSeparator ? ["noSeparator"] : []), true), (props.separatorEnd ? ["separatorEnd"] : []), true), (props.inline || props.dlInline ? __spreadArray(["inline"], (props.dlInline ? ['dlInline'] : []), true) : []), true), (props.alignItems ? ["ai".concat(props.alignItems)] : []), true), (props.justify ? ["jc".concat(props.justify)] : []), true), (props.direction ? ["direction".concat(props.direction)] : []), true), (props.dlHeight ? ["dlHeight".concat(props.dlHeight)] : []), true), (props.noShrinkChild ? ["noShrinkChild".concat(props.noShrinkChild)] : []), true), (props.growChild ? ["growChild".concat(props.growChild)] : []), true), (props.dtColor ? ["dt".concat(props.dtColor)] : []), true), (props.dtNowrap ? ['dtNowrap'] : []), true), (props.dtFlex ? ['dtFlex'] : []), true), (props.ddFlex ? ['ddFlex'] : []), true), (props.isWrap ? ['wrap'] : []), true), (props.iconPos ? [props.iconPos] : []), true), (props.spColumn ? ['spColumn'] : []), true), (props.ddTextAlign ? ["ddTextAlign".concat(headerCase(props.ddTextAlign))] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true), (props.mtsp !== undefined ? utilClassNames({ mtsp: props.mtsp }) : []), true), (props.dn ? utilClassNames({ dn: props.dn }) : []), true);
    return (jsxRuntimeExports.jsxs("dl", __assign({ className: classNames('a-dl', {
            modifiers: modifiers,
            add: props.addClass,
            utils: utils,
        }) }, { children: [jsxRuntimeExports.jsxs("dt", __assign({}, (props.dtWidth && { style: { width: "".concat(props.dtWidth, "px") } }), { children: [props.icon && props.iconPos === 'front' && jsxRuntimeExports.jsx(Icon, { iconName: props.icon, size: props.iconSize }), props.title, props.dtNode, props.icon && props.iconPos === 'back' && jsxRuntimeExports.jsx(Icon, { iconName: props.icon, size: props.iconSize })] })), jsxRuntimeExports.jsx("dd", { children: props.children })] })));
};

/**
 * 見出しです。<br />
 * `level`に応じたhtmlタグになります。<br />
 * t通常のタグレベルと異なるサイズにしたい場合は`type`合わせたいレベルと指定してください。<br />
 * ガイドについてh2,h3タグは装飾が異なります。詳細は[ガイド制作ルール](https://confluence.askul.co.jp/x/T4veYQ)を参照ください。
 *
 * | level | pc | sp |
 * |---|---|---|
 * |h1 |28px |22px|
 * |h2 |25px |20px|
 * |h3 |22px |18px|
 * |h4 |18px |16px|
 * |h5 |16px |14px|
 * |h6 |14px |14px|
 * |p  |14px |14px|
 */
var Heading = function (props) {
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
        "type".concat(props.type ? props.type : props.level)
    ], (props.spType ? ["spType".concat(props.spType)] : []), true), (props.hasIcon ? ['hasIcon'] : []), true), (props.iconPos ? ["iconPos".concat(props.iconPos)] : []), true), (props.modifier ? [props.modifier] : []), true), (props.color ? [props.color] : []), true), (props.align ? [props.align] : []), true), (props.maxline ? ["maxline".concat(props.maxline)] : []), true), (props.hasSquare ? ['hasSquare'] : []), true), (props.hasBtn ? ['hasBtn'] : []), true), (props.hasLink ? ['hasLink'] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true), (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true), (props.textalign ? utilClassNames({ textalign: props.textalign }) : []), true);
    var headingUtils = __spreadArray([], (props.maxline ? [UtilTextMaxLineClass] : []), true);
    var RenderHeading = function () {
        var Tag = props.level;
        return (jsxRuntimeExports.jsx(Tag, __assign({ className: classNames('a-heading_text', { utils: headingUtils }), "data-maxline": props.maxline }, { children: props.hasLink ? (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['base', 'alignLeft', 'noBorder'], iconPos: "right", iconSize: 8, icon: "icon_angle_right_black" }, (props.href && { href: props.href }), (props.modal && { modal: props.modal }), { children: jsxRuntimeExports.jsx("span", __assign({ className: "a-heading_text_link" }, { children: props.children })) })) })) : (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: props.children })) })));
    };
    return (jsxRuntimeExports.jsxs("div", __assign({ id: props.id, className: classNames('a-heading', { modifiers: modifiers, add: props.addClass, utils: utils }) }, { children: [props.modifier === 'attention' && jsxRuntimeExports.jsx(Icon, { iconName: "icon_attention_red", size: 24 }), jsxRuntimeExports.jsx(RenderHeading, {})] })));
};

/**
 * リストです。<br />
 * デフォルトではdotがつきます。
 */
var List = function (props) {
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.noDot ? ['noDot'] : []), true), (props.margin ? ["margin".concat(props.margin)] : []), true), (props.color ? [props.color] : []), true), (props.isNested ? ['nested'] : []), true);
    var utils = __spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.fontsize !== undefined ? utilClassNames({ fontsize: props.fontsize }) : []), true);
    var Tag = props.useTag || 'ul';
    return (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: props.ordered ? (jsxRuntimeExports.jsx("ol", __assign({ className: classNames('a-list -ordered', { modifiers: modifiers, utils: utils }) }, { children: props.children }))) : (jsxRuntimeExports.jsx(Tag, __assign({ className: classNames('a-list', { modifiers: modifiers, utils: utils }) }, { children: props.children }))) }));
};
var ListItem = function (props) {
    var modifiers = __spreadArray([], (props.color ? [props.color] : []), true);
    var Tag = props.useTag || 'li';
    return jsxRuntimeExports.jsx(Tag, __assign({ className: classNames('a-listitem', { modifiers: modifiers }) }, { children: props.children }));
};

/**
 * リンクグループです<br />
 * `Anchorlink`,`Textlink`が子コンポーネントとして入ります。
 */
var LinkGroup = function (_a) {
    var space = _a.space, vertical = _a.vertical, spVertical = _a.spVertical, align = _a.align, justify = _a.justify, isNoSeparator = _a.isNoSeparator, isSpNoSeparator = _a.isSpNoSeparator, separatorType = _a.separatorType, hmargin = _a.hmargin, isTab = _a.isTab, isScroll = _a.isScroll, isSpScroll = _a.isSpScroll, props = __rest(_a, ["space", "vertical", "spVertical", "align", "justify", "isNoSeparator", "isSpNoSeparator", "separatorType", "hmargin", "isTab", "isScroll", "isSpScroll"]);
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (vertical ? ['vertical'] : []), true), (spVertical ? ['spVertical'] : []), true), (space ? [space] : []), true), (align ? ["ai".concat(align)] : []), true), (justify ? ["jc".concat(justify)] : []), true), (isNoSeparator ? ["noSeparator"] : []), true), (isSpNoSeparator ? ["spNoSeparator"] : []), true), (separatorType ? [separatorType] : []), true), (hmargin ? ["hmargin".concat(hmargin)] : []), true), (isTab ? ['tab'] : []), true), (isScroll ? ['scroll'] : []), true), (isSpScroll ? ['spScroll'] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true), (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true), (props.dn ? utilClassNames({ dn: props.dn }) : []), true);
    var Tag = props.useTag ? props.useTag : 'ul';
    var allLinks = React.Children.toArray(props.children).map(function (child, idx) { return (jsxRuntimeExports.jsx("li", __assign({ className: classNames('m-linkGroup_item', {}) }, { children: child }), idx)); });
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-linkGroup', { modifiers: modifiers, add: props.addClass, utils: utils }) }, { children: jsxRuntimeExports.jsx(Tag, __assign({ className: classNames('m-linkGroup_inner') }, { children: allLinks })) })));
};
LinkGroup.defaultProps = {
    hmargin: 16,
};

/**
 * お知らせのリスト
 */
var InfoList = function (props) {
    return (jsxRuntimeExports.jsx(Box, __assign({ addClass: ['m-information_infolistBox'], theme: "white", spacing: props.isLinkGroup ? 'verticalNarrow' : 'narrow' }, (!props.isCol && { mt: 16 }), { children: props.isLinkGroup ? (jsxRuntimeExports.jsx(LinkGroup, __assign({ space: "narrow" }, { children: props.infos.map(function (info, idx) {
                return info.href ? (jsxRuntimeExports.jsx(Textlink, __assign({ href: info.href }, { children: info.title }), idx)) : (jsxRuntimeExports.jsx(Text, __assign({ color: "black" }, { children: info.title }), idx));
            }) }))) : (jsxRuntimeExports.jsx(List, __assign({ margin: props.isSp ? 16 : 8 }, { children: props.infos.map(function (info, idx) { return (jsxRuntimeExports.jsx(ListItem, { children: info.href ? jsxRuntimeExports.jsx(Textlink, __assign({ href: info.href }, { children: info.title })) : info.title }, idx)); }) }))) })));
};
/**
 * 注意などを表示します。<br />
 * 通知の表示位置と色は、注意の適用範囲や重要度によって異なります。<br />
 * <b>色のルール</b><br />
 * ```
 * 赤：エラーなど、青：情報通知など、グレー：注記など
 * ```<br />
 * <b>アイコンのルール</b><br />
 * ```
 * ！：エラー、i：情報通知及び注記
 * ```<br />
 * 以上を適宜組み合わせて利用します。<br />
 * 基本ルールはAK_通知系.ppt内に定めていますので、ご確認ください。<br />
 */
var Information = function (_a) {
    var _b, _c, _d, _e, _f;
    var infos = _a.infos, props = __rest(_a, ["infos"]);
    var utils = __spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true);
    var modifiers = __spreadArray(__spreadArray([], (props.modifiers ? props.modifiers : []), true), (props.isCol ? ["isCol"] : []), true);
    var Tag = props.useTag || 'p';
    var TagTitle = props.useTag || 'span';
    var Content = function () {
        return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [infos && jsxRuntimeExports.jsx(InfoList, { infos: infos, isCol: props.isCol, isSp: props.isSp, isLinkGroup: props.isLinkGroup }), props.children && jsxRuntimeExports.jsx("div", __assign({ className: "m-information_textcontent" }, { children: props.children }))] }));
    };
    return (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('m-information', { modifiers: modifiers, utils: utils }) }, { children: [jsxRuntimeExports.jsxs(Tag, __assign({ className: classNames('m-information_hdg', {
                    modifiers: __spreadArray(__spreadArray(__spreadArray([], (props.title || props.customTitle ? [] : ['noTitle']), true), (props.hide ? ['hasHide'] : []), true), (props.sidehide ? ['hasSideHide'] : []), true),
                }) }, { children: [props.hide && (jsxRuntimeExports.jsx("span", __assign({ className: "m-information_hide" }, { children: jsxRuntimeExports.jsx(Textlink, __assign({ href: "#close", icon: "icon_close", iconSize: 12, iconPos: "back" }, { children: jsxRuntimeExports.jsx(Span, __assign({ spSrOnly: true }, { children: "\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u975E\u8868\u793A" })) })) }))), !((_b = props.modifiers) === null || _b === void 0 ? void 0 : _b.includes('noIcon')) && (jsxRuntimeExports.jsx("span", __assign({ className: "m-information_hdgicon" }, { children: jsxRuntimeExports.jsx(Icon, { iconName: ((_c = props.modifiers) === null || _c === void 0 ? void 0 : _c.includes('warning'))
                                ? 'icon_information_red'
                                : ((_d = props.modifiers) === null || _d === void 0 ? void 0 : _d.includes('description'))
                                    ? 'icon_information_bk'
                                    : ((_e = props.modifiers) === null || _e === void 0 ? void 0 : _e.includes('small'))
                                        ? 'icon_attention_blue'
                                        : 'icon_information_blue', size: 24 }) }))), (props.title || props.customTitle) && (jsxRuntimeExports.jsxs(TagTitle, __assign({ className: "m-information_hdgmain" }, { children: [props.title && jsxRuntimeExports.jsx("span", __assign({ className: classNames('m-information_hdgmain_text', {}) }, { children: props.title })), ((_f = props.customTitle) === null || _f === void 0 ? void 0 : _f.element) && (jsxRuntimeExports.jsx(TagTitle, __assign({ className: classNames('m-information_hdgmain_customElement', {
                                    modifiers: __spreadArray(__spreadArray([], (props.customTitle.noLhCap ? ['noLhCap'] : []), true), (props.customTitle.linkWithoutUnderline ? ['linkWithoutUnderline'] : []), true),
                                }) }, { children: props.customTitle.element })))] }))), props.description && jsxRuntimeExports.jsx("span", __assign({ className: "m-information_description" }, { children: props.description }))] })), props.isCol ? (jsxRuntimeExports.jsx("div", __assign({ className: "m-information_colcontainer" }, { children: jsxRuntimeExports.jsx(Content, {}) }))) : (jsxRuntimeExports.jsx(Content, {})), props.sidehide && (jsxRuntimeExports.jsx("span", __assign({ className: "m-information_hide m-information_hide-side" }, { children: jsxRuntimeExports.jsx(Textlink, __assign({ href: "#close", icon: "icon_close", iconSize: 12, iconPos: "back" }, { children: jsxRuntimeExports.jsx(Span, __assign({ spSrOnly: true }, { children: "\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u975E\u8868\u793A" })) })) })))] })));
};

/**
 * Select
 */
var Select = function (_a) {
    var onChange = _a.onChange, name = _a.name, options = _a.options, disabled = _a.disabled, readOnly = _a.readOnly, select = _a.select, defaultValue = _a.defaultValue, id = _a.id, title = _a.title, multiple = _a.multiple;
    return (jsxRuntimeExports.jsxs("span", __assign({ className: classNames('a-pulldown_select', { modifiers: select }) }, { children: [jsxRuntimeExports.jsx("select", __assign({ defaultValue: defaultValue, onChange: onChange, name: name, disabled: disabled ? true : readOnly ? true : false, id: id, multiple: multiple, title: title }, { children: options && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [options.map(function (option, idx) { return (jsxRuntimeExports.jsx("option", __assign({ value: option.value, hidden: option.isHidden, selected: option.isSelected, disabled: option.isDisabled, "data-id": option.dataId }, { children: option.label }), idx)); }), options.some(function (option) { return option.label.length > 16; }) && jsxRuntimeExports.jsx("optgroup", { label: "" })] })) })), readOnly && jsxRuntimeExports.jsx("input", { className: "a-pulldown_selectInput", type: "hidden", name: name, value: "" })] })));
};
/**
 * pulldownセレクト
 */
var Pulldown = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 48 : _b, modifiers = _a.modifiers, isFull = _a.isFull, isAuto = _a.isAuto, label = _a.label, labelPos = _a.labelPos, weight = _a.weight, isEllipsis = _a.isEllipsis, isError = _a.isError, addClass = _a.addClass, fontsize = _a.fontsize, props = __rest(_a, ["size", "modifiers", "isFull", "isAuto", "label", "labelPos", "weight", "isEllipsis", "isError", "addClass", "fontsize"]);
    var states = __spreadArray([], (isError ? ['error'] : []), true);
    var modifier = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
        "size".concat(String(size))
    ], (modifiers ? [modifiers] : []), true), (isFull ? ['full'] : []), true), (fontsize ? ["fontsize".concat(fontsize)] : []), true), (weight ? [weight] : []), true), (isAuto ? ['auto'] : []), true), (isEllipsis ? ['ellipsis'] : []), true);
    var utils = __spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true);
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames('a-pulldown js-lazy-img', { modifiers: modifier, states: states, utils: utils, add: addClass }) }, { children: label ? (jsxRuntimeExports.jsxs("label", __assign({ className: classNames('a-pulldown_label', {
                modifiers: labelPos ? [labelPos] : [],
            }) }, { children: [!(labelPos === 'right') && jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-pulldown_labeltxt') }, { children: label })), jsxRuntimeExports.jsx(Select, __assign({}, props)), labelPos === 'right' && jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-pulldown_labeltxt') }, { children: label }))] }))) : (jsxRuntimeExports.jsx(Select, __assign({}, props))) })));
};

// TODO js実装後に要調整
/**
 * input要素です。
 */
var Input = function (_a) {
    var value = _a.value, isComplete = _a.isComplete, isDelete = _a.isDelete, isDatepicker = _a.isDatepicker, isSuggest = _a.isSuggest, modalId = _a.modalId, useTag = _a.useTag, props = __rest(_a, ["value", "isComplete", "isDelete", "isDatepicker", "isSuggest", "modalId", "useTag"]);
    var hasIcon = isComplete || isDelete || isDatepicker || isSuggest;
    var Tag = useTag || 'span';
    return (jsxRuntimeExports.jsxs(Tag, __assign({ className: classNames('a-textinput_inputwrap') }, { children: [jsxRuntimeExports.jsx("input", __assign({ className: classNames('a-textinput_input', { modifiers: __spreadArray([], (hasIcon ? ['hasicon'] : []), true) }), "data-micromodal-trigger": modalId, defaultValue: value }, props, (isSuggest && { autoComplete: 'new-password' }))), isComplete && (jsxRuntimeExports.jsx("span", __assign({ className: "a-textinput_complete" }, { children: jsxRuntimeExports.jsx(Icon, { iconName: "icon_check_circle_green" }) }))), isDelete && (jsxRuntimeExports.jsx("span", __assign({ className: "a-textinput_clear js-inputCrear" }, { children: jsxRuntimeExports.jsx(Icon, { iconName: "icon_close", size: 8 }) }))), (isDatepicker || props.type === 'date') && (jsxRuntimeExports.jsx("span", __assign({ className: "a-textinput_datepicker" }, { children: !props.disabled ? jsxRuntimeExports.jsx(Icon, { iconName: "icon_calendar" }) : jsxRuntimeExports.jsx(Icon, { iconName: "icon_calendar_disabled" }) }))), isSuggest && (jsxRuntimeExports.jsx("span", __assign({ className: "a-textinput_suggest" }, { children: jsxRuntimeExports.jsx(Icon, { iconName: "icon_search_gray" }) })))] })));
};
/**
 * テキスト入力用のinput要素
 */
var TextInput = function (_a) {
    var theme = _a.theme, size = _a.size, align = _a.align, label = _a.label, labelPos = _a.labelPos, modifiers = _a.modifiers, isError = _a.isError, inputAlign = _a.inputAlign, mb = _a.mb, add = _a.add, datePickerDuration = _a.datePickerDuration, datePickerDisabled = _a.datePickerDisabled, datePickerAddDisabled = _a.datePickerAddDisabled, props = __rest(_a, ["theme", "size", "align", "label", "labelPos", "modifiers", "isError", "inputAlign", "mb", "add", "datePickerDuration", "datePickerDisabled", "datePickerAddDisabled"]);
    var addclass = __spreadArray(['js-input'], (add ? [add] : []), true);
    var states = __spreadArray([], (isError ? ['error'] : []), true);
    var modifier = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (typeof modifiers === 'string' ? [modifiers] : modifiers === undefined ? [] : modifiers), true), (theme ? [theme] : []), true), (size ? ["size".concat(String(size))] : []), true), (align ? [align] : []), true), (inputAlign ? ["inputAlign".concat(String(inputAlign))] : []), true), (props.type === 'date' ? ['date'] : []), true);
    var utils = __spreadArray([], (mb !== undefined ? utilClassNames({ mb: mb }) : []), true);
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames('a-textinput', { modifiers: modifier, states: states, add: addclass, utils: utils }) }, (datePickerDuration && { 'data-datepicker-duration': datePickerDuration }), (datePickerDisabled && { 'data-datepicker-disabled': datePickerDisabled }), (datePickerAddDisabled && { 'data-datepicker-add-disabled': datePickerAddDisabled }), { children: label ? (jsxRuntimeExports.jsxs("label", __assign({ className: classNames('a-textinput_label', { modifiers: labelPos ? [labelPos] : [] }) }, { children: [jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-textinput_labeltxt') }, { children: label })), jsxRuntimeExports.jsx(Input, __assign({}, props))] }))) : (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: jsxRuntimeExports.jsx(Input, __assign({}, props)) })) })));
};
Input.defaultProps = {
    type: 'text',
};

/**
 * 中身をflexで横並びするパーツです。<br/>
 * - marginに数値を指定すると、directionがrowなどの横系の際は横に、columnなどの縦系の際は縦にマージンがつきます。<br/>
 * - `wrap`をtrueにすると折り返します。<br/>
 * - `wrap`が`true`で`wrapVMargin`を指定すると子要素に縦マージンがつき折り返しても縦に間が空きます。<br/>
 * - `noShrinkChild`を指定すると指定した順番にある子要素が`flex-shrink: 0`になり縮まなくなります。
 */
var ColBox = function (props) {
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.modifier ? (typeof props.modifier === 'string' ? [props.modifier] : props.modifier) : []), true), (props.justify ? ["jc".concat(props.justify)] : []), true), (props.spJustify ? ["spJc".concat(props.spJustify)] : []), true), (props.alignItems ? ["ai".concat(props.alignItems)] : []), true), (props.spAlignItems ? ["spAi".concat(props.spAlignItems)] : []), true), (props.margin ? ["margin".concat(props.margin)] : []), true), (props.spMargin !== undefined ? ["spMargin".concat(props.spMargin)] : []), true), (props.col ? ["col".concat(props.col)] : []), true), (props.spCol ? ["spCol".concat(props.spCol)] : []), true), (props.direction ? ["fd".concat(props.direction)] : []), true), (props.wrap ? ["flwrap"] : []), true), (props.wrap && props.wrapVMargin ? ["wrapVMargin".concat(props.wrapVMargin)] : []), true), (props.noShrinkChild ? ["noShrinkChild".concat(props.noShrinkChild)] : []), true), (props.growChild ? ["growChild".concat(props.growChild)] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true), (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true), (props.mtsp !== undefined ? utilClassNames({ mtsp: props.mtsp }) : []), true), (props.mr !== undefined ? utilClassNames({ mr: props.mr }) : []), true), (props.pt !== undefined ? utilClassNames({ pt: props.pt }) : []), true), (props.dn ? utilClassNames({ dn: props.dn }) : []), true);
    var Tag = props.useTag || 'div';
    return (jsxRuntimeExports.jsx(Tag, __assign({ className: classNames('o-colBox', { modifiers: modifiers, utils: utils, add: props.addClass }), style: { width: props.width } }, { children: props.children })));
};
/**
 * colbox内でRWD,SP時に挙動を変える際や全体のalign等を微調整したい際に使用するラッパー要素です。
 */
var ColItem = function (props) {
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.flex ? ["flex".concat(props.flex)] : []), true), (props.spFlex ? ["spFlex".concat(props.spFlex)] : []), true), (props.spWidthFixed ? ['spWidthFixed'] : []), true), (props.spFull ? ['spFull'] : []), true);
    var style = __assign(__assign({}, (props.width && { flex: "0 0 ".concat(typeof props.width === 'number' ? "".concat(props.width, "px") : props.width) })), (props.maxWidth && {
        maxWidth: "".concat(typeof props.maxWidth === 'number' ? "".concat(props.maxWidth, "px") : props.maxWidth),
    }));
    var Tag = props.useTag || 'div';
    return (jsxRuntimeExports.jsx(Tag, __assign({ className: classNames('a-colitem', { modifiers: modifiers, add: props.addClass }), style: style }, { children: props.children })));
};
ColBox.defaultProps = {
    wrapVMargin: 8,
};

/**
 * カゴボタン<br />
 * 数量を「10+」にするとinputに切り替わります。
 */
var Addcart = function (props) {
    var options = [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' },
        { value: '10', label: '10+' },
    ];
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.cartBtn ? [props.cartBtn] : []), true), (props.withLabel ? ['withLabel'] : []), true), (props.modalOpen ? ['modalOpen'] : []), true), (props.isSp ? ['sp'] : []), true), (props.isNobtn ? ['isNobtn'] : []), true), (props.isApplication ? ['isApplication'] : []), true), (props.isApply ? ['apply'] : []), true), (props.isSpShort ? ['spShort'] : []), true), (props.withLabelSp ? ['withLabelSp'] : []), true), (props.isCenter ? ['isCenter'] : []), true), (props.isRight ? ['isRight'] : []), true), (props.inProductdetail ? ['inProductdetail'] : []), true), (props.isVertical ? ['vertical'] : []), true), (props.isLabelBold ? ['labelBold'] : []), true);
    var utils = __spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true);
    var value = props.value !== undefined ? props.value : 1;
    var modalId = props.isSp ? 'modal-SP_SLPSRC015' : 'modal-SLPSRC015';
    if (props.emptyValue)
        options.unshift({ value: '', label: props.emptyValue });
    var size = props.isNobtn && props.size ? props.size : props.cartBtn === 'xsmall' ? 24 : props.cartBtn === 'small' ? 32 : 48;
    var add = __spreadArray(['js-addcart'], (props.addClass ? props.addClass : []), true);
    return (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('m-addcart', { modifiers: modifiers, utils: utils, add: add }) }, { children: [!props.isNoQuantity && (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('m-addcart_input', { modifiers: props.inputSize }) }, { children: [jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-addcart_pulldown', { add: Number(value) < 10 ? undefined : 'u-dn-all' }) }, { children: jsxRuntimeExports.jsx(Pulldown, { options: options.map(function (option) { return (option.value === "".concat(value) ? __assign(__assign({}, option), { isSelected: true }) : option); }), size: size, isFull: props.inputSize === 'wide', label: props.withLabel ? (props.label ? props.label : '数量') : undefined, id: props.id, title: props.withLabel ? undefined : '数量' }) })), jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-addcart_textinput', { add: Number(value) < 10 ? 'u-dn-all' : undefined }) }, { children: jsxRuntimeExports.jsx(TextInput, { type: "number", value: value, min: 1, max: 999, size: size, modifiers: "small", label: props.withLabel ? (props.label ? props.label : '数量') : undefined, title: props.withLabel ? undefined : '数量' }) }))] }))), !props.isNobtn && (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: props.isApplication ? (jsxRuntimeExports.jsx(Btn, __assign({ buttonOnClick: props.onClick, dataAttr: props.buttonAttributes, modifiers: props.cartBtn !== 'large' ? ['primary', 'small'] : ['primary'] }, { children: "\u7533\u8FBC\u307F\u753B\u9762\u3078" }))) : props.isApply ? (jsxRuntimeExports.jsx(Btn, __assign({ buttonOnClick: props.onClick, dataAttr: props.buttonAttributes, modifiers: ['primary'], href: "dummy" }, { children: "\u7533\u8FBC\u307F\u753B\u9762\u3078" }))) : (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: props.cartBtn === 'small' || props.cartBtn === 'xsmall' ? (props.modalOpen || props.isSp ? (jsxRuntimeExports.jsx(Btn, __assign({ buttonOnClick: props.onClick, dataAttr: props.buttonAttributes, modifiers: ['primary', props.cartBtn === 'xsmall' ? 'xsmall' : 'small'], modal: modalId, icon: props.isCartIcon ? 'icon_cart_white' : undefined }, { children: props.cartText || 'カゴへ' }))) : props.floatId ? (jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Btn, __assign({ buttonOnClick: props.onClick, dataAttr: props.buttonAttributes, addcart: props.floatId, modifiers: ['primary', props.cartBtn === 'xsmall' ? 'xsmall' : 'small'], icon: props.isCartIcon ? 'icon_cart_white' : undefined }, { children: props.cartText || 'カゴへ' })) })) : (jsxRuntimeExports.jsx(Btn, __assign({ buttonOnClick: props.onClick, dataAttr: props.buttonAttributes, addcart: props.floatId, modifiers: __spreadArray([
                            'primary'
                        ], (props.cartBtn === 'xsmall' ? ['xsmall', 'xshort'] : ['small']), true), icon: props.isCartIcon ? 'icon_cart_white' : undefined }, { children: props.cartText || 'カゴへ' })))) : props.modalOpen || props.isSp ? (jsxRuntimeExports.jsx(Btn, __assign({ buttonOnClick: props.onClick, dataAttr: props.buttonAttributes, modifiers: props.cartBtn !== 'large' ? ['primary', 'small'] : ['primary'], icon: props.cartBtn === 'large' || props.isCartIcon ? 'icon_cart_white' : undefined, iconPos: "left", modal: modalId }, { children: props.cartText || 'カゴに入れる' }))) : (jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Btn, __assign({ buttonOnClick: props.onClick, dataAttr: props.buttonAttributes, addcart: props.floatId, icon: props.cartBtn === 'large' || props.isCartIcon ? 'icon_cart_white' : undefined, modifiers: props.cartBtn !== 'large' ? ['primary', 'small'] : ['primary'] }, { children: props.cartText || 'カゴに入れる' })) })) })) }))] })));
};

var Ctrlbtn = forwardRef(function (props, ref) {
    var modifiers = [props.type];
    var states = __spreadArray([], (props.disabled ? ['disabled'] : []), true);
    var add = props.addClass === undefined ? ['js-lazy-img'] : __spreadArray(__spreadArray([], props.addClass, true), ['js-lazy-img'], false);
    return (props.href || props.disabled) && !props.isButtonTag ? (jsxRuntimeExports.jsx(Link, __assign({ href: props.href, overrideClass: classNames('a-ctrlbtn', {
            modifiers: modifiers,
            states: states,
            add: add,
        }) }, { children: jsxRuntimeExports.jsx("span", __assign({ className: "a-ctrlbtn_text" }, { children: props.children ? props.children : props.type === 'next' ? '次へ' : '前へ' })) }))) : (jsxRuntimeExports.jsx("button", __assign({ ref: ref, className: classNames('a-ctrlbtn', { modifiers: modifiers, states: states, add: add }), type: "button", disabled: props.disabled }, { children: jsxRuntimeExports.jsx("span", __assign({ className: "a-ctrlbtn_text" }, { children: props.children ? props.children : props.type === 'next' ? '次へ' : '前へ' })) })));
});
Ctrlbtn.displayName = 'Ctrlbtn';
Ctrlbtn.defaultProps = {
    disabled: false,
};

/**
 * カルーセルです。<br />
 * ライブラリ[swiper](https://github.com/nolimits4web/swiper)を使用しています。<br />
 * 子コンポーネントは必ず`CarouselSlide`を使用してください。<br />
 * ※StorybookのDocs内ではうまく表示されないため、各ドキュメントページにて確認してください。
 */
var Carousel$1 = function (props) {
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.type ? [props.type] : []), true), (props.perview === 'auto' ? ['slideWidthAuto'] : []), true), (props.inmodal ? ['inmodal'] : []), true), (props.spacing ? [props.spacing] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true), (props.pl !== undefined ? utilClassNames({ pl: props.pl }) : []), true), (props.pr !== undefined ? utilClassNames({ pr: props.pr }) : []), true);
    return (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('o-carousel js-carousel js-lazy-img', {
            modifiers: modifiers,
            utils: utils,
            states: props.state,
            add: props.addClass,
        }), "data-spdisabled": props.isSpDisabled }, { children: [props.type === 'navRecommend' && (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('o-carousel_btns', {}) }, { children: [jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['small'], add: ['o-carousel_prev', 'js-carousel_prev'] }, { children: jsxRuntimeExports.jsx(Icon, { iconName: "icon_angle_left_black", size: 8 }) })), jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['small'], add: ['o-carousel_next', 'js-carousel_next'] }, { children: jsxRuntimeExports.jsx(Icon, { iconName: "icon_angle_right_black", size: 8 }) }))] }))), jsxRuntimeExports.jsx("div", __assign({ className: classNames('swiper-container', { add: 'js-carousel-body' }), "data-type": props.type, "data-perview": props.perview, "data-spperview": props.spperview, "data-space": props.space }, (props.colFixed && { 'data-colfixed': props.colFixed }), { children: jsxRuntimeExports.jsx("div", __assign({ className: "swiper-wrapper" }, { children: props.children })) })), (props.type === 'pagination' ||
                props.type === 'percolumn' ||
                props.type === 'recently' ||
                props.type === 'responsiveDelete' ||
                props.type === 'relatedCategory') && (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('o-carousel_pagination', { add: 'js-carousel_pagination' }) }, { children: ["\u30DA\u30FC\u30B8\uFF1A", jsxRuntimeExports.jsx("span", { className: classNames('o-carousel_count', { add: 'js-carousel_count' }) }), jsxRuntimeExports.jsx(Textlink, __assign({ href: "#", addClass: ['o-carousel_toFirst', 'js-carousel_toFirst'] }, { children: "\u6700\u521D\u306B\u623B\u308B" }))] }))), props.type === 'tutorialpop' && (jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['tertiary', 'short', 'center', 'small'], add: ['js-carousel_next', 'o-carousel_nextBtn'] }, { children: "\u6B21\u3078" }))), (props.type === 'top' || props.type === 'topSp' || props.type === 'tutorialpop') && (jsxRuntimeExports.jsx("div", { className: "o-carousel_paginationDots" })), props.type === 'tutorialpop' && (jsxRuntimeExports.jsx(Textlink, __assign({ addClass: ['o-carousel_skiplink', 'js-carousel_skiplink'], size: "small", isBtn: true }, { children: "\u30B9\u30AD\u30C3\u30D7" }))), props.type === 'productvisual' && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('o-carousel_pagination', { add: 'js-carousel_pagination' }) }, { children: jsxRuntimeExports.jsx("span", { className: classNames('o-carousel_count', { add: 'js-carousel_count' }) }) }))), props.type === 'navRecommend' && (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('o-carousel_btns', {}) }, { children: [jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['small'], add: ['o-carousel_prev', 'js-carousel_prev'] }, { children: jsxRuntimeExports.jsx(Icon, { iconName: "icon_angle_left_black", size: 8 }) })), jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['small'], add: ['o-carousel_next', 'js-carousel_next'] }, { children: jsxRuntimeExports.jsx(Icon, { iconName: "icon_angle_right_black", size: 8 }) }))] }))), props.type !== 'tutorialpop' && props.type !== 'navRecommend' && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Ctrlbtn, __assign({ type: "prev", addClass: ['o-carousel_prev', 'js-carousel_prev'] }, { children: "\u524D\u306E\u30B9\u30E9\u30A4\u30C9\u3078" })), jsxRuntimeExports.jsx(Ctrlbtn, __assign({ type: "next", addClass: ['o-carousel_next', 'js-carousel_next'] }, { children: "\u6B21\u306E\u30B9\u30E9\u30A4\u30C9\u3078" }))] }))] })));
};
Carousel$1.defaultProps = {
    space: 24,
};
/**
 * カルーセル内のslideです。
 */
var CarouselSlide = function (props) {
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames('o-carousel_slide swiper-slide js-carousel_slide', { add: props.addClass }) }, { children: jsxRuntimeExports.jsxs("div", __assign({ className: "o-carousel_slideinner", style: { width: props.width && "".concat(props.width, "px") } }, { children: [props.children, props.hasdeleteBtn && (jsxRuntimeExports.jsx("button", __assign({ className: classNames('o-carousel_deleteBtn', { add: 'js-carousel_deleteBtn' }), type: "button" }, { children: jsxRuntimeExports.jsx(Icon, { iconName: "icon_close", alt: "\u524A\u9664", size: 8 }) })))] })) })));
};

/**
 * 商品カセットのコンポーネントです。<br/>
 * Gridに入れる際はItemCardですが、そうではないときはこのコンポーネントを使うことが多いです。<br />
 * 商品カセットに関わる要素は利用するエリアや用途に合わせてパーツや大きさを任意にご調整ください。<br />
 * 基本的な考え方は<a href="https://askul.backlog.jp/alias/file/1096096173" target="_blank">こちらの資料</a>ご参照ください。
 */
var SimpleItemCard = function (props) {
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.direction ? [props.direction] : []), true), (props.spDirection ? ["sp".concat(capitalizeFirstLetter(props.spDirection))] : []), true), (props.modifier ? [props.modifier] : []), true), (props.rank ? ['ranked'] : []), true), (props.isOutsideRank ? ['isOutsideRank'] : []), true), (props.imgSize ? ["imgSize".concat(capitalizeFirstLetter(props.imgSize))] : []), true), (props.isResponsive ? ['responsive'] : []), true), (props.spacing ? [props.spacing] : []), true), (props.imgOnlySize ? ["imgOnly".concat(capitalizeFirstLetter(props.imgOnlySize))] : []), true), (props.aiCenter && props.direction === 'horizontal' ? ['aiCenter'] : []), true), (props.imgPos ? ["imgPos".concat(capitalizeFirstLetter(props.imgPos))] : []), true);
    var states = props.disabled ? 'disabled' : undefined;
    var utils = __spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mbsp !== undefined ? utilClassNames({ mbsp: props.mbsp }) : []), true);
    var carouselImages = __spreadArray([props.img], [props.carouselImages], false);
    var ImageItems = function () { return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [props.tag && !props.rank && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_tag', {}) }, { children: typeof props.tag === 'string' ? (jsxRuntimeExports.jsx(Tag, { label: props.tag })) : (jsxRuntimeExports.jsx(TagList, { tags: props.tag.map(function (tag) { return ({ label: tag }); }), mb: 8 })) }))), jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_img', {}) }, { children: jsxRuntimeExports.jsx(Img, { src: props.img, aspectRatio: !props.isNoLazy ? props.aspectRatio : undefined, lazy: !props.isNoLazy, alt: props.alt ? props.alt : props.name ? props.name : undefined, radius: true, overlayText: props.disabled, width: props.imgWidth, height: props.imgHeight, pos: props.imgPos }) })), props.tag && props.rank && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_tag', {}) }, { children: typeof props.tag === 'string' ? (jsxRuntimeExports.jsx(Tag, { label: props.tag })) : (jsxRuntimeExports.jsx(TagList, { tags: props.tag.map(function (tag) { return ({ label: tag }); }), mb: 8 })) }))), props.rank && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_rank') }, { children: jsxRuntimeExports.jsx(RankingIcon, { rank: props.rank }) }))), props.name && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_name', {}) }, { children: jsxRuntimeExports.jsx(Text, __assign({ maxline: props.maxline }, { children: props.name })) })))] })); };
    return (jsxRuntimeExports.jsx("div", __assign({ style: props.style, className: classNames('m-simpleitemcard', { modifiers: modifiers, add: props.addClass, states: states, utils: utils }) }, { children: props.direction === 'horizontal' ? (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [props.tag && !props.rank && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_tag', {}) }, { children: typeof props.tag === 'string' ? (jsxRuntimeExports.jsx(Tag, { label: props.tag })) : (jsxRuntimeExports.jsx(TagList, { tags: props.tag.map(function (tag) { return ({ label: tag }); }), mb: 8 })) }))), jsxRuntimeExports.jsxs("div", __assign({ className: classNames('m-simpleitemcard_inner', {}) }, { children: [jsxRuntimeExports.jsxs("div", __assign({ className: "m-simpleitemcard_body" }, { children: [props.tag && props.rank && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_tag', {}) }, { children: typeof props.tag === 'string' ? (jsxRuntimeExports.jsx(Tag, { label: props.tag })) : (jsxRuntimeExports.jsx(TagList, { tags: props.tag.map(function (tag) { return ({ label: tag }); }), mb: 8 })) }))), props.expiredText && (jsxRuntimeExports.jsx("div", __assign({ className: "m-simpleitemcard_expiredText" }, { children: jsxRuntimeExports.jsx(Text, __assign({ color: "red", weight: "bold", mb: 12 }, { children: props.expiredText })) }))), props.dateAdded && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_dateAdded', {}) }, { children: jsxRuntimeExports.jsxs(Text, { children: ["\u767B\u9332\u65E5\uFF1A", props.dateAdded] }) }))), props.name &&
                                    (props.useHeadingName ? (jsxRuntimeExports.jsx(Textlink, __assign({ href: props.href, title: props.name, maxline: props.maxline, addClass: ['m-simpleitemcard_name'] }, { children: jsxRuntimeExports.jsx(Heading, __assign({ level: props.useHeadingName, type: "h4" }, { children: props.name })) }))) : (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_name', {}) }, { children: props.href ? (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Text, __assign({ mb: props.applicationNumber ? 20 : undefined }, { children: jsxRuntimeExports.jsx(Textlink, __assign({ href: props.href, title: props.name, maxline: props.maxline }, { children: props.name })) })), props.applicationNumber && (jsxRuntimeExports.jsx("div", __assign({ className: "m-simpleitemcard_applicationNumber" }, { children: jsxRuntimeExports.jsx(Dl, __assign({ title: "\u304A\u7533\u8FBC\u756A\u53F7", fontWeight: "dtNormal" }, { children: props.applicationNumber })) })))] })) : (jsxRuntimeExports.jsx(Text, __assign({ add: ['u-text-16'] }, { children: props.name }))) })))), props.modifier === 'attachedService' && (jsxRuntimeExports.jsxs("div", __assign({ className: "m-simpleitemcard_quantity" }, { children: [jsxRuntimeExports.jsxs(Text, __assign({ mb: 12 }, { children: ["\u6570\u91CF", props.hasSeparator && jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: "\uFF1A" })] })), jsxRuntimeExports.jsx(Text, { children: "1" })] }))), props.rating && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_rate', {}) }, { children: jsxRuntimeExports.jsx(StarIconGroup, { rate: props.rating.rate, reviewHref: props.rating.reviewHref, review: props.rating.review, viewEvaluation: props.rating.viewEvaluation, size: props.rating.size }) }))), props.salesUnit && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_salesUnit', {}) }, { children: jsxRuntimeExports.jsxs(Dl, __assign({ title: "\u8CA9\u58F2\u5358\u4F4D" }, { children: ["1", props.salesUnit] })) }))), props.price && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_price', {}) }, { children: props.bulkBuying ? (jsxRuntimeExports.jsx(Dl, __assign({ title: props.priceHdg }, { children: jsxRuntimeExports.jsx(Price, { value: props.price, afterValue: props.modifier !== 'attachedService' ? '（税込）' : undefined, size: props.priceSize }) }))) : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [props.priceHdg && jsxRuntimeExports.jsx(Text, { children: props.priceHdg }), jsxRuntimeExports.jsx(Price, { value: props.price, afterValue: props.modifier !== 'attachedService' ? '（税込）' : undefined, size: props.priceSize, isFrom: props.priceIsFrom }), props.assemblyPrice && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Text, __assign({ add: "m-simpleitemcard_assemblyPrice" }, { children: "\u7D44\u7ACB\uFF0F\u8A2D\u7F6E\u8CBB\uFF08\u7A0E\u8FBC\uFF09" })), jsxRuntimeExports.jsx(Price, { value: props.assemblyPrice, afterValue: props.modifier !== 'attachedService' ? '（税込）' : undefined, size: props.priceSize, isFrom: props.priceIsFrom })] })), props.attachPrice && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Text, __assign({ add: "m-simpleitemcard_attachPrice" }, { children: "\u4ED8\u5C5E\u91D1\u984D\u8868\u793A\u540D\uFF08\u7A0E\u8FBC\uFF09" })), jsxRuntimeExports.jsx(Price, { value: props.attachPrice, afterValue: props.modifier !== 'attachedService' ? '（税込）' : undefined, size: props.priceSize, isFrom: props.priceIsFrom })] }))] })) }))), props.unitPrice && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_unitPrice', {}) }, { children: jsxRuntimeExports.jsx(Dl, __assign({ title: "1\u672C\u3042\u305F\u308A", alignItems: "center" }, { children: jsxRuntimeExports.jsx(Price, { value: props.unitPrice, afterValue: props.modifier !== 'attachedService' ? '（税込）' : undefined, size: "small" }) })) }))), props.lastOrdered && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_lastOrdered', {}) }, { children: jsxRuntimeExports.jsx(Dl, __assign({ size: "small", fontWeight: "dtNormal", title: "\u524D\u56DE\u6CE8\u6587\u65E5", direction: "pcColumn", space: 8 }, { children: props.lastOrdered })) }))), props.itemNumber && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_productnum', {}) }, { children: jsxRuntimeExports.jsxs(Text, { children: ["\u8CDE\u54C1\u756A\u53F7\uFF1A", props.itemNumber] }) }))), props.deliveryAddress && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_deliveryAddress', {}) }, { children: jsxRuntimeExports.jsxs(Text, { children: ["\u304A\u5C4A\u3051\u5148", jsxRuntimeExports.jsx("br", {}), props.deliveryAddress] }) }))), props.infoText && (jsxRuntimeExports.jsx(Box, __assign({ theme: "information", spacing: "verticalNarrow", mt: 12 }, { children: jsxRuntimeExports.jsx(Information, { modifiers: ['noIcon'], title: jsxRuntimeExports.jsx(Span, __assign({ weight: "normal" }, { children: props.infoText })) }) }))), props.addcart && (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: !props.disabled ? (jsxRuntimeExports.jsx(Addcart, { floatId: props.addcart })) : (jsxRuntimeExports.jsx("div", __assign({ className: "m-simpleitemcard_message" }, { children: jsxRuntimeExports.jsx(Box, __assign({ theme: "warning", align: "center", spacing: "narrow" }, { children: jsxRuntimeExports.jsx(Text, __assign({ color: "red" }, { children: "\u73FE\u5728\u3054\u6CE8\u6587\u3044\u305F\u3060\u3051\u307E\u305B\u3093" })) })) }))) })), props.addBtn && (jsxRuntimeExports.jsx("div", __assign({ className: "m-simpleitemcard_addBtn" }, { children: jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['primary', 'small', 'base'] }, { children: props.addBtn })) })))] })), jsxRuntimeExports.jsxs("div", __assign({ className: "m-simpleitemcard_section" }, { children: [props.href ? (jsxRuntimeExports.jsx(Link, __assign({ href: props.href, overrideClass: "m-simpleitemcard_link", title: props.name }, { children: jsxRuntimeExports.jsxs("div", __assign({ className: classNames('m-simpleitemcard_img', {}) }, { children: [props.rank && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_rank') }, { children: jsxRuntimeExports.jsx(RankingIcon, { rank: props.rank }) }))), jsxRuntimeExports.jsx(Img, { src: props.img, alt: props.name, aspectRatio: !props.isNoLazy ? props.aspectRatio : undefined, lazy: !props.isNoLazy, radius: true, width: props.imgWidth, height: props.imgHeight, pos: props.imgPos })] })) }))) : (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('m-simpleitemcard_img', {}) }, { children: [props.rank && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_rank') }, { children: jsxRuntimeExports.jsx(RankingIcon, { rank: props.rank }) }))), jsxRuntimeExports.jsx(Img, { src: props.img, alt: props.name, aspectRatio: !props.isNoLazy ? props.aspectRatio : undefined, lazy: !props.isNoLazy, radius: true, width: props.imgWidth, height: props.imgHeight, pos: props.imgPos })] }))), props.deleteBtn && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_deleteBtn', {}) }, { children: jsxRuntimeExports.jsx(Textlink, __assign({ href: "javascript:;", addClass: ['js-carousel_deleteBtn'], icon: "icon_trash", iconPos: "front" }, { children: "\u524A\u9664" })) })))] }))] })), props.addBtnFoot && (jsxRuntimeExports.jsx("div", __assign({ className: "m-simpleitemcard_addBtnFoot" }, { children: jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['small'] }, { children: props.addBtnFoot })) })))] })) : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [!props.carouselImages || props.disabled ? (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: props.href ? (jsxRuntimeExports.jsx(Link, __assign({ href: props.href, overrideClass: classNames('m-simpleitemcard_link', {
                            add: props.isComparison ? 'js-bottomTrackingAddComparison_targetImg' : '',
                        }), title: props.name }, { children: jsxRuntimeExports.jsx(ImageItems, {}) }))) : (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_link', {
                            add: props.isComparison ? 'js-bottomTrackingAddComparison_targetImg' : '',
                        }) }, { children: jsxRuntimeExports.jsx(ImageItems, {}) }))) })) : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [props.tag && !props.rank && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_tag', {}) }, { children: typeof props.tag === 'string' ? (jsxRuntimeExports.jsx(Tag, { label: props.tag })) : (jsxRuntimeExports.jsx(TagList, { tags: props.tag.map(function (tag) { return ({ label: tag }); }), mb: 8 })) }))), jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_img', {}) }, { children: jsxRuntimeExports.jsx(Carousel$1, __assign({ perview: 1 }, { children: carouselImages.map(function (item, idx) { return (jsxRuntimeExports.jsx(CarouselSlide, __assign({ addClass: props.isComparison && idx === 0 ? 'js-bottomTrackingAddComparison_targetImg' : '' }, { children: jsxRuntimeExports.jsx(Img, { href: props.href, src: props.img, aspectRatio: !props.isNoLazy ? props.aspectRatio : undefined, lazy: !props.isNoLazy, alt: props.alt ? props.alt : props.name ? props.name : undefined, radius: true, width: 124, height: 124 }) }), idx)); }) })) })), props.tag && props.rank && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_tag', {}) }, { children: typeof props.tag === 'string' ? (jsxRuntimeExports.jsx(Tag, { label: props.tag })) : (jsxRuntimeExports.jsx(TagList, { tags: props.tag.map(function (tag) { return ({ label: tag }); }), mb: 8 })) }))), props.rank && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_rank') }, { children: jsxRuntimeExports.jsx(RankingIcon, { rank: props.rank }) }))), props.name && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_name', {}) }, { children: jsxRuntimeExports.jsx(Text, __assign({ maxline: props.maxline }, { children: props.name })) })))] })), props.rating && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_rate', {}) }, { children: jsxRuntimeExports.jsx(StarIconGroup, { rate: props.rating.rate, reviewHref: props.rating.reviewHref, review: props.rating.review, viewEvaluation: props.rating.viewEvaluation, size: props.rating.size }) }))), props.price && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_price', {}) }, { children: jsxRuntimeExports.jsx(Price, { value: props.price, afterValue: !props.noAfterValue ? '（税込）' : undefined, size: props.priceSize }) }))), props.lastOrdered && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_lastOrdered', {}) }, { children: jsxRuntimeExports.jsx(Dl, __assign({ size: "small", fontWeight: "dtNormal", title: "\u524D\u56DE\u6CE8\u6587\u65E5", direction: "pcColumn", space: 8 }, { children: props.lastOrdered })) }))), props.comment && (jsxRuntimeExports.jsx("div", __assign({ className: "m-simpleitemcard_comment" }, { children: jsxRuntimeExports.jsx(Text, __assign({ size: "small", maxline: 4 }, { children: props.comment })) }))), props.similarImage && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('m-simpleitemcard_similar', {}) }, { children: jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['base', 'small'], href: "dummy" }, { children: "\u753B\u50CF\u304C\u4F3C\u305F\u5546\u54C1" })) }))), props.addcart && (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: !props.disabled ? (jsxRuntimeExports.jsx(Addcart, { floatId: props.addcart, mb: 16 })) : (jsxRuntimeExports.jsx("div", __assign({ className: "m-simpleitemcard_message u-mb-16" }, { children: jsxRuntimeExports.jsx(Box, __assign({ theme: "warning", align: "center", spacing: "narrow" }, { children: jsxRuntimeExports.jsx(Text, __assign({ color: "red" }, { children: "\u73FE\u5728\u3054\u6CE8\u6587\u3044\u305F\u3060\u3051\u307E\u305B\u3093" })) })) }))) })), props.addBtn && (jsxRuntimeExports.jsx("div", __assign({ className: "m-simpleitemcard_addBtn" }, { children: props.addBtn === 'バリエーションへ' ? (jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['tertiary', 'small', 'base'] }, { children: props.addBtn }))) : (jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['primary', 'small', 'base'] }, { children: props.addBtn }))) }))), props.modifier === 'recentChecked' && (jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['small'], add: "js-deleteRecentCheck" }, { children: "\u5C65\u6B74\u304B\u3089\u524A\u9664" })))] })) })));
};
SimpleItemCard.defaultProps = {
    direction: 'vertical',
};

/** 横にスクロールできるコンポーネントです<br/>
 * SPで使われます<br/>
 * 参考URL：<a href="https://d3cp5rvuveg0ea.cloudfront.net/pub-SP_BUY-CRT-001.html" target="_blank">SP_BUY-CRT-001</a>
 */
var HorizontalScroller = function (props) {
    var Tag = props.useTag ? props.useTag : 'ul';
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.margin ? ["margin".concat(props.margin)] : []), true), (props.size ? [props.size] : []), true), (props.hasFilter ? ['hasFilter'] : []), true), (props.isBlock ? ['isBlock'] : []), true), (props.isChangeMaxLine ? ['isChangeMaxLine'] : []), true);
    var utils = __spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true);
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames('o-horizontalScroller', { modifiers: modifiers, utils: utils, add: props.addClass }) }, { children: jsxRuntimeExports.jsx(Tag, __assign({ className: classNames('o-horizontalScroller_inner') }, { children: props.children })) })));
};
HorizontalScroller.defaultProps = {
    margin: 16,
};
var HorizontalScrollerItem = function (props) {
    var Tag = props.useDiv ? 'div' : 'li';
    var modifiers = __spreadArray(__spreadArray([], (props.maxWidth ? ['fullWidth'] : []), true), (props.isShrink ? ['isShrink'] : []), true);
    return (jsxRuntimeExports.jsx(Tag, __assign({ className: classNames('o-horizontalScroller_item', { modifiers: modifiers }), style: { maxWidth: props.maxWidth ? "".concat(props.maxWidth, "px") : undefined } }, { children: props.children })));
};

function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend(target, src) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames = '') {
  const classes = classNames.split(' ').map(c => c.trim()).filter(c => !!c);
  const unique = [];
  classes.forEach(c => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}

/* underscore in name -> watch for changes */
const paramsList = ['modules', 'init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopedSlidesLimit', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

function getParams(obj = {}, splitEvents = true) {
  const params = {
    on: {}
  };
  const events = {};
  const passedParams = {};
  extend(params, Swiper$1.defaults);
  extend(params, Swiper$1.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map(key => key.replace(/_/, ''));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(key => {
    if (typeof obj[key] === 'undefined') return;

    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(key => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events
  };
}

function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper
}, swiperParams) {
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}

const calcLoopedSlides = (slides, swiperParams) => {
  let slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    const breakpoint = Swiper$1.prototype.getBreakpoint(swiperParams.breakpoints);
    const breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  let loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length && swiperParams.loopedSlidesLimit) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
};

function renderLoop(swiper, slides, swiperParams) {
  const modifiedSlides = slides.map((child, index) => {
    return /*#__PURE__*/React__default.cloneElement(child, {
      swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      key: `${child.key}-duplicate-${index}-${position}`,
      className: `${child.props.className || ''} ${swiperParams.slideDuplicateClass}`
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    const blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankSlide = /*#__PURE__*/React__default.createElement("div", {
          className: `${swiperParams.slideClass} ${swiperParams.slideBlankClass}`
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  const loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  const prependSlides = [];
  const appendSlides = [];

  for (let i = 0; i < loopedSlides; i += 1) {
    const index = i - Math.floor(i / modifiedSlides.length) * modifiedSlides.length;
    appendSlides.push(duplicateSlide(modifiedSlides[index], i, 'append'));
    prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - index - 1], i, 'prepend'));
  }

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [...prependSlides, ...modifiedSlides, ...appendSlides];
}

function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;

  const addKey = key => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }

  const watchParams = paramsList.filter(key => key[0] === '_').map(key => key.replace(/_/, ''));
  watchParams.forEach(key => {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(newKey => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(oldKey => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}

function processChildren(c) {
  const slides = [];
  React__default.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(slide => slides.push(slide));
    }
  });
  return slides;
}

function getChildren(c) {
  const slides = [];
  const slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React__default.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(slide => slides.push(slide));
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides,
    slots
  };
}

function updateSwiper({
  swiper,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter(key => key !== 'children' && key !== 'direction');
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  const destroyModule = mod => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(key => {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
    } else {
      const newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}

function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  return slides.filter((child, index) => index >= virtualData.from && index <= virtualData.to).map(child => {
    return /*#__PURE__*/React__default.cloneElement(child, {
      swiper,
      style
    });
  });
}

const updateOnVirtualData = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return useEffect(callback, deps);
  return useLayoutEffect(callback, deps);
}

const SwiperSlideContext = /*#__PURE__*/createContext(null);
const SwiperContext = /*#__PURE__*/createContext(null);
const useSwiper = () => {
  return useContext(SwiperContext);
};

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
const Swiper = /*#__PURE__*/forwardRef(function (_temp, externalElRef) {
  let {
    className,
    tag: Tag = 'div',
    wrapperTag: WrapperTag = 'div',
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = useState('swiper');
  const [virtualData, setVirtualData] = useState(null);
  const [breakpointChanged, setBreakpointChanged] = useState(false);
  const initializedRef = useRef(false);
  const swiperElRef = useRef(null);
  const swiperRef = useRef(null);
  const oldPassedParamsRef = useRef(null);
  const oldSlides = useRef(null);
  const nextElRef = useRef(null);
  const prevElRef = useRef(null);
  const paginationElRef = useRef(null);
  const scrollbarElRef = useRef(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);

  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }

  });

  const initSwiper = () => {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = new Swiper$1(swiperParams);

    swiperRef.current.loopCreate = () => {};

    swiperRef.current.loopDestroy = () => {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };

  if (!swiperElRef.current) {
    initSwiper();
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  const attachEvents = () => {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  const detachEvents = () => {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  useEffect(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  useEffect(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;

    if (swiperRef.current.destroyed) {
      initSwiper();
    }

    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(() => {
    attachEvents();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, c => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return () => {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(child => {
        return /*#__PURE__*/React__default.cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/React__default.createElement(Tag, _extends$1({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ''}`)
  }, restProps), /*#__PURE__*/React__default.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/React__default.createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React__default.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React__default.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
Swiper.displayName = 'Swiper';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SwiperSlide = /*#__PURE__*/forwardRef(function (_temp, externalRef) {
  let {
    tag: Tag = 'div',
    children,
    className = '',
    swiper,
    zoom,
    virtualIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = useRef(null);
  const [slideClasses, setSlideClasses] = useState('swiper-slide');

  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(() => {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return () => {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
  };

  const renderChildren = () => {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/React__default.createElement(Tag, _extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ''}`),
    "data-swiper-slide-index": virtualIndex
  }, rest), /*#__PURE__*/React__default.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, zoom ? /*#__PURE__*/React__default.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren()));
});
SwiperSlide.displayName = 'SwiperSlide';

// https://github.com/nolimits4web/swiper/issues/3855#issuecomment-847627094
var useSwiperRef = function () {
    var _a = useState(null), wrapper = _a[0], setWrapper = _a[1];
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current) {
            setWrapper(ref.current);
        }
    }, []);
    return [wrapper, ref];
};
Swiper$1.use([Grid, Navigation, Pagination, A11y, Scrollbar, Autoplay, Manipulation]);
var DeleteBtn = function (_a) {
    var type = _a.type, slidesPerView = _a.slidesPerView, deleteBtnOnClick = _a.deleteBtnOnClick;
    var swiper = useSwiper();
    var deleteClickHandler = function (e) {
        var _a;
        var target = e.target;
        if (!(target instanceof HTMLElement))
            return;
        if (deleteBtnOnClick)
            deleteBtnOnClick(e);
        if (swiper.slides.length === 1) {
            (_a = target.closest('.js-carousel-parent')) === null || _a === void 0 ? void 0 : _a.remove();
        }
        swiper.removeSlide(swiper.clickedIndex);
        // MYP-MYP-001 スライドを削除した際の挙動調整
        if (type === 'responsiveDelete' && window.matchMedia('screen and (min-width: 1230px)').matches) {
            if (swiper.slides.length - 1 - slidesPerView <= swiper.clickedIndex + 1 &&
                (swiper.slides.length - 1) % slidesPerView === 1) {
                swiper.slideTo(swiper.slides.length - slidesPerView + 1);
            }
        }
    };
    return (jsxRuntimeExports.jsx("button", __assign({ className: classNames('o-carousel_deleteBtn'), type: "button", onClick: function (e) { return deleteClickHandler(e); } }, { children: jsxRuntimeExports.jsx(Icon, { iconName: "icon_close", alt: "\u524A\u9664", size: 8, isSrcProd: true }) })));
};
var Carousel = function (_a) {
    var slidesPerView = _a.slidesPerView, type = _a.type, spaceBetween = _a.spaceBetween, slides = _a.slides, perview = _a.perview, inmodal = _a.inmodal, spacing = _a.spacing, mb = _a.mb, mt = _a.mt, pl = _a.pl, pr = _a.pr;
    var _b = useSwiperRef(), nextEl = _b[0], nextElRef = _b[1];
    var _c = useSwiperRef(), prevEl = _c[0], prevElRef = _c[1];
    var _d = useSwiperRef(), paginationEl = _d[0], paginationRef = _d[1];
    var toFirstEl = useRef(null);
    var swiperRef = useRef(null);
    var toFirstClickHandler = function (e) {
        var _a;
        e.preventDefault();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore ↓定義されていないよう
        (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.swiper.slideToLoop(0);
    };
    var isLoop = type === 'pagination';
    var isLoopFillGroupWithBlank = type === 'pagination';
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (type ? [type] : []), true), (perview === 'auto' ? ['slideWidthAuto'] : []), true), (inmodal ? ['inmodal'] : []), true), (spacing ? [spacing] : []), true);
    var utils = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (mb !== undefined ? utilClassNames({ mb: mb }) : []), true), (mt !== undefined ? utilClassNames({ mt: mt }) : []), true), (pl !== undefined ? utilClassNames({ pl: pl }) : []), true), (pr !== undefined ? utilClassNames({ pr: pr }) : []), true);
    return (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('o-carousel', { modifiers: modifiers, utils: utils }) }, { children: [jsxRuntimeExports.jsx(Swiper, __assign({ speed: 500, loop: isLoop, loopFillGroupWithBlank: isLoopFillGroupWithBlank, className: "swiper-container", ref: swiperRef, pagination: {
                    el: paginationEl,
                    type: 'fraction',
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' + '／' + '<span class="' + totalClass + '"></span>';
                    },
                }, onAfterInit: function (swiper) {
                    var _a;
                    (_a = toFirstEl === null || toFirstEl === void 0 ? void 0 : toFirstEl.current) === null || _a === void 0 ? void 0 : _a.classList.add('u-dn-all');
                    if (typeof swiper.params.slidesPerView !== 'number')
                        return;
                    // swiper.navigation.nextEl?.classList.toggle('u-dn-all', slidesPerView <= swiper.params.slidesPerView);
                    // swiper.navigation.prevEl?.classList.toggle('u-dn-all', slidesPerView <= swiper.params.slidesPerView);
                }, onResize: function (swiper) {
                    var _a;
                    if (typeof swiper.params.slidesPerView !== 'number')
                        return;
                    (_a = toFirstEl === null || toFirstEl === void 0 ? void 0 : toFirstEl.current) === null || _a === void 0 ? void 0 : _a.classList.toggle('u-dn-all', slidesPerView <= swiper.params.slidesPerView);
                    // nextEl?.classList.toggle('u-dn-all', slidesPerView <= swiper.params.slidesPerView);
                    // prevEl?.classList.toggle('u-dn-all', slidesPerView <= swiper.params.slidesPerView);
                }, onSlideChange: function (swiper) {
                    var _a;
                    if (toFirstEl !== null) {
                        (_a = toFirstEl === null || toFirstEl === void 0 ? void 0 : toFirstEl.current) === null || _a === void 0 ? void 0 : _a.classList.toggle('u-dn-all', swiper.realIndex === 0);
                    }
                }, navigation: {
                    prevEl: prevEl,
                    nextEl: nextEl,
                }, 
                // onBeforeInit={onBeforeInit}
                spaceBetween: spaceBetween, slidesPerView: slidesPerView, slidesPerGroup: slidesPerView }, { children: slides.map(function (item, idx) { return (jsxRuntimeExports.jsx(SwiperSlide, __assign({ className: classNames('o-carousel_slide') }, { children: jsxRuntimeExports.jsxs("div", __assign({ className: "o-carousel_slideinner", style: { width: item.width && "".concat(item.width, "px") } }, { children: [item.children, item.hasdeleteBtn && (jsxRuntimeExports.jsx(DeleteBtn, { type: type, slidesPerView: slidesPerView, deleteBtnOnClick: item.deleteBtnOnClick }))] })) }), idx)); }) })), (type === 'pagination' ||
                type === 'percolumn' ||
                type === 'recently' ||
                type === 'responsiveDelete' ||
                type === 'relatedCategory') && (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('o-carousel_pagination') }, { children: ["\u30DA\u30FC\u30B8\uFF1A", jsxRuntimeExports.jsx("span", { ref: paginationRef, className: classNames('o-carousel_count') }), jsxRuntimeExports.jsx(Textlink, __assign({ href: "#", addClass: ['o-carousel_toFirst', 'u-dn-all'], ref: toFirstEl, onClick: function (e) { return toFirstClickHandler(e); } }, { children: "\u6700\u521D\u306B\u623B\u308B" }))] }))), type !== 'tutorialpop' && type !== 'navRecommend' && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Ctrlbtn, __assign({ type: "prev", addClass: ['o-carousel_prev'], ref: prevElRef }, { children: "\u524D\u306E\u30B9\u30E9\u30A4\u30C9\u3078" })), jsxRuntimeExports.jsx(Ctrlbtn, __assign({ type: "next", addClass: ['o-carousel_next'], ref: nextElRef }, { children: "\u6B21\u306E\u30B9\u30E9\u30A4\u30C9\u3078" }))] }))] })));
};

var FooterRecentCheckItems = function (_a) {
    var isSp = _a.isSp, listLinkHref = _a.listLinkHref, carouselItems = _a.carouselItems;
    var carouselItemArray = carouselItems === null || carouselItems === void 0 ? void 0 : carouselItems.map(function (item) {
        var _a;
        return ({
            children: (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Img, { src: item.img, href: item.href, alt: "dummy", width: 140, height: 140, mb: 16 }), item.cartAlertMessage ? (jsxRuntimeExports.jsx(Box, __assign({ theme: "warning", spacing: "xnarrow", mb: 16 }, { children: jsxRuntimeExports.jsx(Text, __assign({ size: "small", color: "red", textalign: "center" }, { children: item.cartAlertMessage })) }))) : (((_a = item.addCartButton) === null || _a === void 0 ? void 0 : _a.onClick) && (jsxRuntimeExports.jsx(Addcart, { onClick: item.addCartButton.onClick, cartBtn: "xsmall", isNoQuantity: true, mb: 16, buttonAttributes: item.addCartButton.attributes }))), jsxRuntimeExports.jsx(Textlink, __assign({}, (item.price && { mb: 12 }), { maxline: 3, href: item.href }, { children: item.name })), item.price && jsxRuntimeExports.jsx(Price, { value: item.price, afterValue: "\uFF08\u7A0E\u8FBC\uFF09" })] })),
            hasdeleteBtn: true,
            deleteBtnOnClick: item.deleteBtnOnClick,
        });
    });
    return (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('o-footer_recentCheckItems js-carousel-parent') }, { children: [jsxRuntimeExports.jsxs(ColBox, __assign({ margin: 24 }, { children: [jsxRuntimeExports.jsx(Heading, __assign({ level: "h2", type: "h3", mb: 24 }, { children: "\u6700\u8FD1\u30C1\u30A7\u30C3\u30AF\u3057\u305F\u5546\u54C1" })), !isSp && (jsxRuntimeExports.jsx(Text, { children: jsxRuntimeExports.jsx(Textlink, __assign({ href: listLinkHref }, { children: "\u4E00\u89A7\u3092\u898B\u308B" })) }))] })), isSp ? (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('o-footer_recentCheckItemsSp', {}) }, { children: [jsxRuntimeExports.jsx(HorizontalScroller, __assign({ size: "small", mb: 24 }, { children: carouselItems === null || carouselItems === void 0 ? void 0 : carouselItems.map(function (item) { return (jsxRuntimeExports.jsx(HorizontalScrollerItem, { children: jsxRuntimeExports.jsx(SimpleItemCard, { href: item.href, img: item.img, alt: item.alt }) }, item.href)); }) })), jsxRuntimeExports.jsx(Text, __assign({ textalign: "right" }, { children: jsxRuntimeExports.jsx(Textlink, __assign({ href: listLinkHref }, { children: "\u4E00\u89A7\u3092\u898B\u308B" })) }))] }))) : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("div", __assign({ className: classNames('o-footer_recentCheckItemsPc', {}) }, { children: jsxRuntimeExports.jsx(Carousel, { slidesPerView: 9, spaceBetween: 24, type: "recently", slides: carouselItemArray }) })), jsxRuntimeExports.jsxs("div", __assign({ className: classNames('o-footer_recentCheckItemsSp', {}) }, { children: [jsxRuntimeExports.jsx(HorizontalScroller, __assign({ size: "small", mb: 24 }, { children: carouselItems === null || carouselItems === void 0 ? void 0 : carouselItems.map(function (item) { return (jsxRuntimeExports.jsx(HorizontalScrollerItem, { children: jsxRuntimeExports.jsx(SimpleItemCard, { href: item.href, img: item.img, alt: item.alt }) }, item.href)); }) })), jsxRuntimeExports.jsx(Text, __assign({ textalign: "right" }, { children: jsxRuntimeExports.jsx(Textlink, __assign({ href: listLinkHref }, { children: "\u4E00\u89A7\u3092\u898B\u308B" })) }))] }))] }))] })));
};

/**
 * textarea要素です。
 */
var Textarea = forwardRef(function (_a, ref) {
    var _b, _c;
    var lineHeight = _a.lineHeight, modifiers = _a.modifiers, mb = _a.mb, isError = _a.isError, placeholder = _a.placeholder, height = _a.height, add = _a.add, onChange = _a.onChange, props = __rest(_a, ["lineHeight", "modifiers", "mb", "isError", "placeholder", "height", "add", "onChange"]);
    var hasMuliplaceholder = placeholder && ((_b = /([\n\r])/) === null || _b === void 0 ? void 0 : _b.test(placeholder));
    var states = __spreadArray([], (isError ? ['error'] : []), true);
    var modifier = __spreadArray(__spreadArray([], (modifiers ? [modifiers] : []), true), (lineHeight ? ["lh".concat(lineHeight)] : []), true);
    var addClass = __spreadArray(__spreadArray([], (add ? add : []), true), (hasMuliplaceholder ? ['js-multiplePlaceholder'] : []), true);
    var utils = __spreadArray([], (mb !== undefined ? utilClassNames({ mb: mb }) : []), true);
    var customPlaceholder = placeholder
        ? ((_c = /([\n\r])/) === null || _c === void 0 ? void 0 : _c.test(placeholder))
            ? nl2br(placeholder)
            : placeholder
        : undefined;
    return (jsxRuntimeExports.jsxs("div", __assign({ className: classNames('a-textarea', { modifiers: modifier, states: states, utils: utils, add: addClass }) }, { children: [jsxRuntimeExports.jsx("textarea", __assign({ placeholder: placeholder && !hasMuliplaceholder ? placeholder : undefined }, props, { style: { height: height }, onChange: onChange, ref: ref })), hasMuliplaceholder && jsxRuntimeExports.jsx("div", __assign({ className: classNames('a-textarea_multiplePlaceholder') }, { children: customPlaceholder }))] })));
});
Textarea.displayName = 'Textarea';
Textarea.defaultProps = {
    rows: 6,
};

/**
 * 注釈コンポーネントです。デフォルトでは「※」がはいります。
 */
var Caption = function (props) {
    var modifiers = __spreadArray([], (props.color ? [props.color] : []), true);
    var utils = __spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true);
    return (jsxRuntimeExports.jsx("ul", __assign({ className: classNames('a-caption', {
            utils: utils,
            modifiers: modifiers,
        }) }, { children: props.children })));
};
/**
 * 注釈のリストです。
 */
var CaptionItem = function (props) {
    var modifiers = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (props.size ? ["em".concat(props.size)] : []), true), (props.captionLevel ? ["level".concat(props.captionLevel)] : []), true), (props.fontsize ? ["fz".concat(props.fontsize)] : []), true), (props.color ? [props.color] : []), true);
    var utils = __spreadArray(__spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true), (props.mt !== undefined ? utilClassNames({ mt: props.mt }) : []), true);
    return (jsxRuntimeExports.jsxs("li", __assign({ className: classNames('a-caption_item', {
            modifiers: modifiers,
            add: props.addClass,
            utils: utils,
        }) }, { children: [jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-caption_chr') }, { children: props.captionItem })), props.children] })));
};
CaptionItem.defaultProps = {
    captionItem: '※',
};

var OpinionBoxContent = function (props) {
    var submitBtnElement = useRef(null);
    var textAreaElement = useRef(null);
    var checkTextAreaCount = function (textAreaElm) {
        var valueLen = textAreaElm === null || textAreaElm === void 0 ? void 0 : textAreaElm.value.trim().length;
        var btnElm = submitBtnElement.current;
        if (valueLen === 0) {
            btnElm === null || btnElm === void 0 ? void 0 : btnElm.setAttribute('disabled', 'disabled');
            btnElm === null || btnElm === void 0 ? void 0 : btnElm.classList.add('is-disabled');
        }
        else if (btnElm === null || btnElm === void 0 ? void 0 : btnElm.classList.contains('is-disabled')) {
            btnElm === null || btnElm === void 0 ? void 0 : btnElm.removeAttribute('disabled');
            btnElm === null || btnElm === void 0 ? void 0 : btnElm.classList.remove('is-disabled');
        }
    };
    var submitOpinionBtnHandle = function (e) {
        props.setIsSend(true);
        props.submitOpinionBtnOnClick && props.submitOpinionBtnOnClick(e, textAreaElement.current);
    };
    useEffect(function () {
        var btnElm = submitBtnElement.current;
        btnElm === null || btnElm === void 0 ? void 0 : btnElm.setAttribute('disabled', 'disabled');
        btnElm === null || btnElm === void 0 ? void 0 : btnElm.classList.add('is-disabled');
    });
    return (jsxRuntimeExports.jsxs("div", __assign({ className: "o-opinionbox_content js-opinionBox_content" }, { children: [jsxRuntimeExports.jsxs(Text, { children: ["\u5546\u54C1\u306E\u5206\u985E\u3084\u3001\u30AD\u30FC\u30EF\u30FC\u30C9\u691C\u7D22\u306A\u3069\u5546\u54C1\u691C\u7D22\u306B\u3064\u3044\u3066\u3001\u5177\u4F53\u7684\u306A\u3054\u610F\u898B\u3092\u304A\u805E\u304B\u305B\u304F\u3060\u3055\u3044\u3002\u4ECA\u5F8C\u306E\u30B5\u30A4\u30C8\u6539\u5584\u306E\u53C2\u8003\u306B\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002\u3054\u5165\u529B\u3044\u305F\u3060\u3044\u305F\u3054\u610F\u898B\u306B\u5BFE\u3057\u3066\u306F\u3001\u30A2\u30B9\u30AF\u30EB\u304B\u3089\u76F4\u63A5\u56DE\u7B54\u306F\u3057\u3066\u304A\u308A\u307E\u305B\u3093\u306E\u3067\u3001\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002", jsxRuntimeExports.jsx("br", {}), jsxRuntimeExports.jsx(Textlink, __assign({ href: props.inquiryHref, target: "_blank" }, { children: "\u5546\u54C1\u306E\u304A\u554F\u3044\u5408\u308F\u305B" }))] }), jsxRuntimeExports.jsxs(ColBox, __assign({ mt: 16, margin: 24 }, { children: [jsxRuntimeExports.jsx(Textarea, { placeholder: "\u3053\u3053\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002\uFF081000\u6587\u5B57\u4EE5\u5185\uFF09", title: "Web\u30B5\u30A4\u30C8\u306E\u4F7F\u3044\u52DD\u624B\u3084\u30C7\u30B6\u30A4\u30F3\u3001\u6A5F\u80FD\u306B\u3064\u3044\u3066\u3054\u610F\u898B\u5165\u529B", ref: textAreaElement, onChange: function (e) { return checkTextAreaCount(textAreaElement.current); } }), jsxRuntimeExports.jsx("div", __assign({ className: "o-opinionbox_inner" }, { children: jsxRuntimeExports.jsx(Btn, __assign({ buttonRef: submitBtnElement, buttonOnClick: submitOpinionBtnHandle, modifiers: ['short', 'base'] }, { children: "\u3054\u610F\u898B\u3092\u9001\u4FE1" })) }))] }))] })));
};
/**
 * サイト改善用のフォーム
 */
var Opinionbox = function (props) {
    var modifiers = __spreadArray([], (props.findProduct ? ['findProduct'] : []), true);
    var _a = useState(false), isSend = _a[0], setIsSend = _a[1];
    var reviewYesBtnElement = useRef(null);
    var reviewNoBtnElement = useRef(null);
    var rootElement = useRef(null);
    var reviewYesHandle = function (e) {
        var reviewYesBtn = reviewYesBtnElement.current;
        var reviewNoBtn = reviewNoBtnElement.current;
        if (reviewYesBtn === null || reviewYesBtn === void 0 ? void 0 : reviewYesBtn.classList.contains('is-selected'))
            return;
        var root = rootElement.current;
        reviewYesBtn === null || reviewYesBtn === void 0 ? void 0 : reviewYesBtn.classList.add('is-selected');
        reviewNoBtn === null || reviewNoBtn === void 0 ? void 0 : reviewNoBtn.classList.remove('is-selected');
        if (!(root === null || root === void 0 ? void 0 : root.classList.contains('is-show'))) {
            root === null || root === void 0 ? void 0 : root.classList.add('is-show');
        }
        props.reviewYesOnClick && props.reviewYesOnClick(e);
    };
    var reviewNoHandle = function (e) {
        var reviewYesBtn = reviewYesBtnElement.current;
        var reviewNoBtn = reviewNoBtnElement.current;
        if (reviewNoBtn === null || reviewNoBtn === void 0 ? void 0 : reviewNoBtn.classList.contains('is-selected'))
            return;
        var root = rootElement.current;
        reviewNoBtn === null || reviewNoBtn === void 0 ? void 0 : reviewNoBtn.classList.add('is-selected');
        reviewYesBtn === null || reviewYesBtn === void 0 ? void 0 : reviewYesBtn.classList.remove('is-selected');
        if (!(root === null || root === void 0 ? void 0 : root.classList.contains('is-show'))) {
            root === null || root === void 0 ? void 0 : root.classList.add('is-show');
        }
        props.reviewNoOnClick && props.reviewNoOnClick(e);
    };
    return (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: jsxRuntimeExports.jsx("div", __assign({ className: classNames('o-opinionbox js-productOpinionBox', {
                modifiers: modifiers,
            }), ref: rootElement }, { children: props.findProduct ? (jsxRuntimeExports.jsx(Box, __assign({ mb: props.mb }, { children: jsxRuntimeExports.jsxs(Information, __assign({ modifiers: ['noIcon', 'description'], useTag: "div", customTitle: {
                        element: (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: !isSend && (jsxRuntimeExports.jsx("div", __assign({ className: "o-opinionbox_hdg" }, { children: jsxRuntimeExports.jsxs(ColBox, __assign({ justify: "between" }, { children: [jsxRuntimeExports.jsxs(ColBox, __assign({ margin: 24 }, { children: [jsxRuntimeExports.jsx(Text, __assign({ size: "large", weight: "bold" }, { children: "\u304A\u63A2\u3057\u306E\u5546\u54C1\u306F\u898B\u3064\u304B\u308A\u307E\u3057\u305F\u304B\uFF1F" })), jsxRuntimeExports.jsxs(ColBox, __assign({ margin: 8, noShrinkChild: "all" }, { children: [jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['small', 'xshort'], buttonOnClick: reviewYesHandle, buttonRef: reviewYesBtnElement }, { children: "\u306F\u3044" })), jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['small', 'xshort'], buttonOnClick: reviewNoHandle, buttonRef: reviewNoBtnElement }, { children: "\u3044\u3044\u3048" }))] }))] })), jsxRuntimeExports.jsx(Btn, __assign({ id: "item-request-modal-open-button", modifiers: ['middle', 'small'], buttonOnClick: props.requestProductBtnOnClick }, { children: "\u5546\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8\u3078" }))] })) }))) })),
                    } }, { children: [!isSend && (jsxRuntimeExports.jsx(OpinionBoxContent, { inquiryHref: props.inquiryHref, setIsSend: setIsSend, submitOpinionBtnOnClick: props.submitOpinionBtnOnClick })), isSend && (jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Text, __assign({ size: "large", weight: "bold" }, { children: "\u3054\u610F\u898B\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3057\u305F\u3002" })) }))] })) }))) : (jsxRuntimeExports.jsx(Box, __assign({ theme: "information" }, { children: jsxRuntimeExports.jsx(Information, __assign({ title: "\u30B5\u30A4\u30C8\u6539\u5584\u306E\u3054\u5354\u529B\u3092\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002", description: "Web\u30B5\u30A4\u30C8\u306E\u4F7F\u3044\u52DD\u624B\u3084\u30C7\u30B6\u30A4\u30F3\u3001\u6A5F\u80FD\u306B\u3064\u3044\u3066\u3054\u610F\u898B\u3092\u304A\u5BC4\u305B\u304F\u3060\u3055\u3044\u3002", modifiers: ['descriptionColorBlack'] }, { children: jsxRuntimeExports.jsxs(ColBox, { children: [jsxRuntimeExports.jsx(Textarea, { placeholder: "\u3053\u3053\u306B\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002", title: "Web\u30B5\u30A4\u30C8\u306E\u4F7F\u3044\u52DD\u624B\u3084\u30C7\u30B6\u30A4\u30F3\u3001\u6A5F\u80FD\u306B\u3064\u3044\u3066\u3054\u610F\u898B\u5165\u529B" }), jsxRuntimeExports.jsxs(Text, { children: [jsxRuntimeExports.jsx(Span, __assign({ weight: "bold" }, { children: "\u8CB4\u91CD\u306A\u3054\u610F\u898B\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059" })), jsxRuntimeExports.jsx("br", {}), "\u3044\u305F\u3060\u304D\u307E\u3057\u305F\u3054\u610F\u898B\u306F\u30B5\u30FC\u30D3\u30B9\u5411\u4E0A\u306B\u5F79\u7ACB\u305F\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059"] }), jsxRuntimeExports.jsxs("div", __assign({ className: "o-opinionbox_inner" }, { children: [jsxRuntimeExports.jsx(Btn, __assign({ modifiers: ['short', 'base'], add: "js-opinionBox_btn" }, { children: "\u3054\u610F\u898B\u3092\u9001\u4FE1" })), jsxRuntimeExports.jsx("div", __assign({ className: "o-opinionbox_caption" }, { children: jsxRuntimeExports.jsxs(Caption, { children: [jsxRuntimeExports.jsxs(CaptionItem, { children: ["\u53D6\u6271\u5546\u54C1\u306E\u8FFD\u52A0\u306F", jsxRuntimeExports.jsx(Textlink, __assign({ modal: "modal-SLPSRC021", icon: "icon_modal", iconPos: "back", iconSize: 14 }, { children: "\u5546\u54C1\u30EA\u30AF\u30A8\u30B9\u30C8" })), "\u304B\u3089\u304A\u9858\u3044\u3057\u307E\u3059\u3002"] }), jsxRuntimeExports.jsx(CaptionItem, { children: "\u3053\u3061\u3089\u306E\u6295\u7A3F\u306B\u306F\u304A\u8FD4\u4E8B\u306F\u3057\u3066\u304A\u308A\u307E\u305B\u3093\u3002" })] }) }))] }))] }) })) }))) })) }));
};

/**
 * 「お探しの商品は見つかりましたか？」ボックス
 */
var FindProductOpinionFormBox = function (_a) {
    var inquiryHref = _a.inquiryHref, reviewYesOnClick = _a.reviewYesOnClick, reviewNoOnClick = _a.reviewNoOnClick, submitOpinionBtnOnClick = _a.submitOpinionBtnOnClick, mb = _a.mb;
    return (jsxRuntimeExports.jsx(Opinionbox, { inquiryHref: inquiryHref, mb: mb, findProduct: true, reviewYesOnClick: reviewYesOnClick, reviewNoOnClick: reviewNoOnClick, requestProductBtnOnClick: function () { return window.Modal.show('modal-SLPSRC021'); }, submitOpinionBtnOnClick: submitOpinionBtnOnClick }));
};

/**
 *
 * 読み込み中などのローディングのアニメーションです。
 *
 */
var Spinner = function (props) {
    var modifiers = __spreadArray(__spreadArray([], (props.isFullWidth ? ['isFullWidth'] : []), true), (props.size ? [props.size] : []), true);
    return (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: props.children ? (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-spinner', { modifiers: modifiers }), role: "status", style: { height: props.height ? props.height : undefined } }, { children: jsxRuntimeExports.jsx("span", { className: classNames('a-spinner_inner', {}) }) })), jsxRuntimeExports.jsx(Text, __assign({ add: "a-spinner_leadText", weight: "bold" }, { children: props.children }))] })) : (jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-spinner', { modifiers: modifiers }), role: "status", style: { height: props.height ? props.height : undefined } }, { children: jsxRuntimeExports.jsx("span", __assign({ className: classNames('a-spinner_inner', {}) }, { children: jsxRuntimeExports.jsx("span", __assign({ className: "a-spinner_text" }, { children: "\u30ED\u30FC\u30C9\u4E2D..." })) })) }))) }));
};

var RecommendContent = function (props) {
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [props.text && (jsxRuntimeExports.jsx("div", __assign({ className: classNames('o-recommendArea_text') }, { children: jsxRuntimeExports.jsx(Text, __assign({ weight: "bold" }, { children: props.text })) }))), props.heading && (jsxRuntimeExports.jsxs(ColBox, __assign({ margin: 24, addClass: ['o-recommendArea_head'] }, { children: [jsxRuntimeExports.jsx(ColItem, { children: jsxRuntimeExports.jsxs(ColBox, __assign({ margin: 24 }, { children: [jsxRuntimeExports.jsx(Heading, __assign({ level: props.hdgLevel ? props.hdgLevel : 'h3', type: props.hdgType ? props.hdgType : 'h3' }, { children: props.heading })), props.link && (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: jsxRuntimeExports.jsx(Text, { children: jsxRuntimeExports.jsx(Textlink, __assign({ href: props.link.href, addClass: ['u-dn-sp'] }, { children: props.link.text ? props.link.text : 'もっと見る' })) }) }))] })) }), props.rankLink && (jsxRuntimeExports.jsx(Dl, __assign({ title: "\u30E9\u30F3\u30AD\u30F3\u30B0\u3092\u307F\u308B", fontWeight: "dtNormal", dn: "sp" }, { children: jsxRuntimeExports.jsx(LinkGroup, __assign({ isNoSeparator: true, useTag: "ol" }, { children: props.rankLink.map(function (rank) { return (jsxRuntimeExports.jsx(Text, { children: jsxRuntimeExports.jsx(Textlink, __assign({ href: rank.href }, { children: rank.text })) }, rank.text)); }) })) })))] }))), props.children, props.rankLink && (jsxRuntimeExports.jsx(Dl, __assign({ title: "\u30E9\u30F3\u30AD\u30F3\u30B0\u3092\u307F\u308B", fontWeight: "dtNormal", alignItems: "baseline", dtNowrap: true, justify: "end", dn: "pc", mt: 24 }, { children: jsxRuntimeExports.jsx(LinkGroup, __assign({ isNoSeparator: true, useTag: "ol" }, { children: props.rankLink.map(function (rank) { return (jsxRuntimeExports.jsx(Text, { children: jsxRuntimeExports.jsx(Textlink, __assign({ href: rank.href }, { children: rank.text })) }, rank.text)); }) })) })))] }));
};
/**
 * レコメンド商品のカルーセルコンポーネントです
 */
var RecommendArea = function (props) {
    var utils = __spreadArray([], (props.mb !== undefined ? utilClassNames({ mb: props.mb }) : []), true);
    var modifiers = __spreadArray(__spreadArray([], (props.modifiers ? [props.modifiers] : []), true), (props.link ? ['hasLink'] : []), true);
    var states = props.state ? props.state : undefined;
    return (jsxRuntimeExports.jsx("div", __assign({ className: classNames('o-recommendArea', { modifiers: modifiers, utils: utils, states: states, add: props.addClass }) }, { children: props.state === 'loading' ? (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("div", __assign({ className: classNames('o-recommendArea_loading') }, { children: jsxRuntimeExports.jsx(Spinner, {}) })), jsxRuntimeExports.jsx("div", __assign({ className: classNames('o-recommendArea_content') }, { children: RecommendContent(props) }))] })) : (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: RecommendContent(props) })) })));
};

var RecommendCarousel = function (_a) {
    var heading = _a.heading, hdgType = _a.hdgType, hdgLevel = _a.hdgLevel, mb = _a.mb, carouselItems = _a.carouselItems;
    var hasTag = carouselItems.some(function (item) { return item.tag; });
    var carouselItemArray = carouselItems === null || carouselItems === void 0 ? void 0 : carouselItems.map(function (item) { return ({
        children: (jsxRuntimeExports.jsx(CarouselSlide, { children: jsxRuntimeExports.jsx(SimpleItemCard, __assign({}, (item.tag === undefined && hasTag && { style: { paddingTop: '32px' } }), { href: item.href, img: item.img, name: item.name, maxline: item.maxline, price: item.price, tag: item.tag, rating: item.rating, imgWidth: 140, imgHeight: 140 })) })),
    }); });
    return (jsxRuntimeExports.jsx(RecommendArea, __assign({ heading: heading, hdgType: hdgType, hdgLevel: hdgLevel, mb: mb }, { children: jsxRuntimeExports.jsx(Carousel, { type: "pagination", slidesPerView: 6, slides: carouselItemArray }) })));
};

export { FindProductOpinionFormBox, FooterRecentCheckItems, RecommendCarousel };
